// source: order-publisher.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
var common_pb = require('./common_pb.js');
goog.object.extend(proto, common_pb);
goog.exportSymbol('proto.order_publisher.AddChangeRequestMessageRequest', null, global);
goog.exportSymbol('proto.order_publisher.ChangeRequestArea', null, global);
goog.exportSymbol('proto.order_publisher.ChangeRequestAttachedFile', null, global);
goog.exportSymbol('proto.order_publisher.ChangeRequestAuthorType', null, global);
goog.exportSymbol('proto.order_publisher.ChangeRequestMessageResponse', null, global);
goog.exportSymbol('proto.order_publisher.ChangeRequestResponse', null, global);
goog.exportSymbol('proto.order_publisher.ChangeRequestStatus', null, global);
goog.exportSymbol('proto.order_publisher.GetChangeRequestRequest', null, global);
goog.exportSymbol('proto.order_publisher.MarkChangeRequestSeenRequest', null, global);
goog.exportSymbol('proto.order_publisher.PublisherOrderBacklink', null, global);
goog.exportSymbol('proto.order_publisher.PublisherOrderFilter', null, global);
goog.exportSymbol('proto.order_publisher.PublisherOrderFilterField', null, global);
goog.exportSymbol('proto.order_publisher.PublisherOrderPageRequest', null, global);
goog.exportSymbol('proto.order_publisher.PublisherOrderPublishedUrlRequest', null, global);
goog.exportSymbol('proto.order_publisher.PublisherOrderResponse', null, global);
goog.exportSymbol('proto.order_publisher.PublisherOrderStatusRequest', null, global);
goog.exportSymbol('proto.order_publisher.PublisherWebsiteCalcPriceRequest', null, global);
goog.exportSymbol('proto.order_publisher.PublisherWebsiteCalcPriceResponse', null, global);
goog.exportSymbol('proto.order_publisher.PublisherWebsiteChangeStatusRequest', null, global);
goog.exportSymbol('proto.order_publisher.PublisherWebsiteCreateRequest', null, global);
goog.exportSymbol('proto.order_publisher.PublisherWebsiteDetailsResponse', null, global);
goog.exportSymbol('proto.order_publisher.PublisherWebsiteFilter', null, global);
goog.exportSymbol('proto.order_publisher.PublisherWebsiteFilterField', null, global);
goog.exportSymbol('proto.order_publisher.PublisherWebsiteImportLatestRequest', null, global);
goog.exportSymbol('proto.order_publisher.PublisherWebsiteImportLaunchRequest', null, global);
goog.exportSymbol('proto.order_publisher.PublisherWebsiteImportResponse', null, global);
goog.exportSymbol('proto.order_publisher.PublisherWebsiteImportStatus', null, global);
goog.exportSymbol('proto.order_publisher.PublisherWebsiteMetrics', null, global);
goog.exportSymbol('proto.order_publisher.PublisherWebsitePageRequest', null, global);
goog.exportSymbol('proto.order_publisher.PublisherWebsiteResponse', null, global);
goog.exportSymbol('proto.order_publisher.PublisherWebsiteSendVerificationEmailRequest', null, global);
goog.exportSymbol('proto.order_publisher.PublisherWebsiteUpdateRequest', null, global);
goog.exportSymbol('proto.order_publisher.PublisherWebsiteVerificationContainer', null, global);
goog.exportSymbol('proto.order_publisher.PublisherWebsiteVerificationOption', null, global);
goog.exportSymbol('proto.order_publisher.PublisherWebsiteVerificationOption.SettingsCase', null, global);
goog.exportSymbol('proto.order_publisher.PublisherWebsiteVerificationRequest', null, global);
goog.exportSymbol('proto.order_publisher.PublisherWebsiteVerificationResponse', null, global);
goog.exportSymbol('proto.order_publisher.SubmitChangesRequest', null, global);
goog.exportSymbol('proto.order_publisher.SubmitNewLiveLinkRequest', null, global);
goog.exportSymbol('proto.order_publisher.SubmittedLiveUrlStatus', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.order_publisher.PublisherWebsitePageRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.order_publisher.PublisherWebsitePageRequest.repeatedFields_, null);
};
goog.inherits(proto.order_publisher.PublisherWebsitePageRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.order_publisher.PublisherWebsitePageRequest.displayName = 'proto.order_publisher.PublisherWebsitePageRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.order_publisher.PublisherWebsiteFilter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.order_publisher.PublisherWebsiteFilter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.order_publisher.PublisherWebsiteFilter.displayName = 'proto.order_publisher.PublisherWebsiteFilter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.order_publisher.PublisherWebsiteResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.order_publisher.PublisherWebsiteResponse.repeatedFields_, null);
};
goog.inherits(proto.order_publisher.PublisherWebsiteResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.order_publisher.PublisherWebsiteResponse.displayName = 'proto.order_publisher.PublisherWebsiteResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.order_publisher.PublisherWebsiteDetailsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.order_publisher.PublisherWebsiteDetailsResponse.repeatedFields_, null);
};
goog.inherits(proto.order_publisher.PublisherWebsiteDetailsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.order_publisher.PublisherWebsiteDetailsResponse.displayName = 'proto.order_publisher.PublisherWebsiteDetailsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.order_publisher.PublisherWebsiteChangeStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.order_publisher.PublisherWebsiteChangeStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.order_publisher.PublisherWebsiteChangeStatusRequest.displayName = 'proto.order_publisher.PublisherWebsiteChangeStatusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.order_publisher.PublisherWebsiteMetrics = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.order_publisher.PublisherWebsiteMetrics, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.order_publisher.PublisherWebsiteMetrics.displayName = 'proto.order_publisher.PublisherWebsiteMetrics';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.order_publisher.PublisherWebsiteCreateRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.order_publisher.PublisherWebsiteCreateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.order_publisher.PublisherWebsiteCreateRequest.displayName = 'proto.order_publisher.PublisherWebsiteCreateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.order_publisher.PublisherWebsiteUpdateRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.order_publisher.PublisherWebsiteUpdateRequest.repeatedFields_, null);
};
goog.inherits(proto.order_publisher.PublisherWebsiteUpdateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.order_publisher.PublisherWebsiteUpdateRequest.displayName = 'proto.order_publisher.PublisherWebsiteUpdateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.order_publisher.PublisherWebsiteCalcPriceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.order_publisher.PublisherWebsiteCalcPriceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.order_publisher.PublisherWebsiteCalcPriceRequest.displayName = 'proto.order_publisher.PublisherWebsiteCalcPriceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.order_publisher.PublisherWebsiteCalcPriceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.order_publisher.PublisherWebsiteCalcPriceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.order_publisher.PublisherWebsiteCalcPriceResponse.displayName = 'proto.order_publisher.PublisherWebsiteCalcPriceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.order_publisher.PublisherWebsiteVerificationContainer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.order_publisher.PublisherWebsiteVerificationContainer.repeatedFields_, null);
};
goog.inherits(proto.order_publisher.PublisherWebsiteVerificationContainer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.order_publisher.PublisherWebsiteVerificationContainer.displayName = 'proto.order_publisher.PublisherWebsiteVerificationContainer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.order_publisher.PublisherWebsiteVerificationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.order_publisher.PublisherWebsiteVerificationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.order_publisher.PublisherWebsiteVerificationRequest.displayName = 'proto.order_publisher.PublisherWebsiteVerificationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.order_publisher.PublisherWebsiteSendVerificationEmailRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.order_publisher.PublisherWebsiteSendVerificationEmailRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.order_publisher.PublisherWebsiteSendVerificationEmailRequest.displayName = 'proto.order_publisher.PublisherWebsiteSendVerificationEmailRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.order_publisher.PublisherWebsiteImportLaunchRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.order_publisher.PublisherWebsiteImportLaunchRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.order_publisher.PublisherWebsiteImportLaunchRequest.displayName = 'proto.order_publisher.PublisherWebsiteImportLaunchRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.order_publisher.PublisherWebsiteImportLatestRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.order_publisher.PublisherWebsiteImportLatestRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.order_publisher.PublisherWebsiteImportLatestRequest.displayName = 'proto.order_publisher.PublisherWebsiteImportLatestRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.order_publisher.PublisherWebsiteImportResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.order_publisher.PublisherWebsiteImportResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.order_publisher.PublisherWebsiteImportResponse.displayName = 'proto.order_publisher.PublisherWebsiteImportResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.order_publisher.PublisherWebsiteVerificationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.order_publisher.PublisherWebsiteVerificationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.order_publisher.PublisherWebsiteVerificationResponse.displayName = 'proto.order_publisher.PublisherWebsiteVerificationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.order_publisher.PublisherWebsiteVerificationOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.order_publisher.PublisherWebsiteVerificationOption.oneofGroups_);
};
goog.inherits(proto.order_publisher.PublisherWebsiteVerificationOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.order_publisher.PublisherWebsiteVerificationOption.displayName = 'proto.order_publisher.PublisherWebsiteVerificationOption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.order_publisher.PublisherOrderPageRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.order_publisher.PublisherOrderPageRequest.repeatedFields_, null);
};
goog.inherits(proto.order_publisher.PublisherOrderPageRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.order_publisher.PublisherOrderPageRequest.displayName = 'proto.order_publisher.PublisherOrderPageRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.order_publisher.PublisherOrderFilter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.order_publisher.PublisherOrderFilter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.order_publisher.PublisherOrderFilter.displayName = 'proto.order_publisher.PublisherOrderFilter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.order_publisher.PublisherOrderResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.order_publisher.PublisherOrderResponse.repeatedFields_, null);
};
goog.inherits(proto.order_publisher.PublisherOrderResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.order_publisher.PublisherOrderResponse.displayName = 'proto.order_publisher.PublisherOrderResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.order_publisher.PublisherOrderBacklink = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.order_publisher.PublisherOrderBacklink, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.order_publisher.PublisherOrderBacklink.displayName = 'proto.order_publisher.PublisherOrderBacklink';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.order_publisher.PublisherOrderStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.order_publisher.PublisherOrderStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.order_publisher.PublisherOrderStatusRequest.displayName = 'proto.order_publisher.PublisherOrderStatusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.order_publisher.PublisherOrderPublishedUrlRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.order_publisher.PublisherOrderPublishedUrlRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.order_publisher.PublisherOrderPublishedUrlRequest.displayName = 'proto.order_publisher.PublisherOrderPublishedUrlRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.order_publisher.ChangeRequestAttachedFile = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.order_publisher.ChangeRequestAttachedFile, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.order_publisher.ChangeRequestAttachedFile.displayName = 'proto.order_publisher.ChangeRequestAttachedFile';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.order_publisher.ChangeRequestMessageResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.order_publisher.ChangeRequestMessageResponse.repeatedFields_, null);
};
goog.inherits(proto.order_publisher.ChangeRequestMessageResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.order_publisher.ChangeRequestMessageResponse.displayName = 'proto.order_publisher.ChangeRequestMessageResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.order_publisher.ChangeRequestResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.order_publisher.ChangeRequestResponse.repeatedFields_, null);
};
goog.inherits(proto.order_publisher.ChangeRequestResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.order_publisher.ChangeRequestResponse.displayName = 'proto.order_publisher.ChangeRequestResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.order_publisher.GetChangeRequestRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.order_publisher.GetChangeRequestRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.order_publisher.GetChangeRequestRequest.displayName = 'proto.order_publisher.GetChangeRequestRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.order_publisher.MarkChangeRequestSeenRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.order_publisher.MarkChangeRequestSeenRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.order_publisher.MarkChangeRequestSeenRequest.displayName = 'proto.order_publisher.MarkChangeRequestSeenRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.order_publisher.SubmitChangesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.order_publisher.SubmitChangesRequest.repeatedFields_, null);
};
goog.inherits(proto.order_publisher.SubmitChangesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.order_publisher.SubmitChangesRequest.displayName = 'proto.order_publisher.SubmitChangesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.order_publisher.SubmitNewLiveLinkRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.order_publisher.SubmitNewLiveLinkRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.order_publisher.SubmitNewLiveLinkRequest.displayName = 'proto.order_publisher.SubmitNewLiveLinkRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.order_publisher.AddChangeRequestMessageRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.order_publisher.AddChangeRequestMessageRequest.repeatedFields_, null);
};
goog.inherits(proto.order_publisher.AddChangeRequestMessageRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.order_publisher.AddChangeRequestMessageRequest.displayName = 'proto.order_publisher.AddChangeRequestMessageRequest';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.order_publisher.PublisherWebsitePageRequest.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.order_publisher.PublisherWebsitePageRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.order_publisher.PublisherWebsitePageRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.order_publisher.PublisherWebsitePageRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.PublisherWebsitePageRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
page: jspb.Message.getFieldWithDefault(msg, 1, 0),
limit: jspb.Message.getFieldWithDefault(msg, 2, 0),
workspaceId: jspb.Message.getFieldWithDefault(msg, 3, 0),
filtersList: jspb.Message.toObjectList(msg.getFiltersList(),
    proto.order_publisher.PublisherWebsiteFilter.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.order_publisher.PublisherWebsitePageRequest}
 */
proto.order_publisher.PublisherWebsitePageRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.order_publisher.PublisherWebsitePageRequest;
  return proto.order_publisher.PublisherWebsitePageRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.order_publisher.PublisherWebsitePageRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.order_publisher.PublisherWebsitePageRequest}
 */
proto.order_publisher.PublisherWebsitePageRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    case 4:
      var value = new proto.order_publisher.PublisherWebsiteFilter;
      reader.readMessage(value,proto.order_publisher.PublisherWebsiteFilter.deserializeBinaryFromReader);
      msg.addFilters(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.order_publisher.PublisherWebsitePageRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.order_publisher.PublisherWebsitePageRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.order_publisher.PublisherWebsitePageRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.PublisherWebsitePageRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getFiltersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.order_publisher.PublisherWebsiteFilter.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 page = 1;
 * @return {number}
 */
proto.order_publisher.PublisherWebsitePageRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsitePageRequest} returns this
 */
proto.order_publisher.PublisherWebsitePageRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 limit = 2;
 * @return {number}
 */
proto.order_publisher.PublisherWebsitePageRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsitePageRequest} returns this
 */
proto.order_publisher.PublisherWebsitePageRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 workspace_id = 3;
 * @return {number}
 */
proto.order_publisher.PublisherWebsitePageRequest.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsitePageRequest} returns this
 */
proto.order_publisher.PublisherWebsitePageRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated PublisherWebsiteFilter filters = 4;
 * @return {!Array<!proto.order_publisher.PublisherWebsiteFilter>}
 */
proto.order_publisher.PublisherWebsitePageRequest.prototype.getFiltersList = function() {
  return /** @type{!Array<!proto.order_publisher.PublisherWebsiteFilter>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.order_publisher.PublisherWebsiteFilter, 4));
};


/**
 * @param {!Array<!proto.order_publisher.PublisherWebsiteFilter>} value
 * @return {!proto.order_publisher.PublisherWebsitePageRequest} returns this
*/
proto.order_publisher.PublisherWebsitePageRequest.prototype.setFiltersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.order_publisher.PublisherWebsiteFilter=} opt_value
 * @param {number=} opt_index
 * @return {!proto.order_publisher.PublisherWebsiteFilter}
 */
proto.order_publisher.PublisherWebsitePageRequest.prototype.addFilters = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.order_publisher.PublisherWebsiteFilter, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.order_publisher.PublisherWebsitePageRequest} returns this
 */
proto.order_publisher.PublisherWebsitePageRequest.prototype.clearFiltersList = function() {
  return this.setFiltersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.order_publisher.PublisherWebsiteFilter.prototype.toObject = function(opt_includeInstance) {
  return proto.order_publisher.PublisherWebsiteFilter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.order_publisher.PublisherWebsiteFilter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.PublisherWebsiteFilter.toObject = function(includeInstance, msg) {
  var f, obj = {
order: jspb.Message.getFieldWithDefault(msg, 1, 0),
field: jspb.Message.getFieldWithDefault(msg, 2, 0),
value: jspb.Message.getFieldWithDefault(msg, 3, ""),
operation: jspb.Message.getFieldWithDefault(msg, 4, 0),
join: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.order_publisher.PublisherWebsiteFilter}
 */
proto.order_publisher.PublisherWebsiteFilter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.order_publisher.PublisherWebsiteFilter;
  return proto.order_publisher.PublisherWebsiteFilter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.order_publisher.PublisherWebsiteFilter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.order_publisher.PublisherWebsiteFilter}
 */
proto.order_publisher.PublisherWebsiteFilter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOrder(value);
      break;
    case 2:
      var value = /** @type {!proto.order_publisher.PublisherWebsiteFilterField} */ (reader.readEnum());
      msg.setField(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    case 4:
      var value = /** @type {!proto.common.FilterOperation} */ (reader.readEnum());
      msg.setOperation(value);
      break;
    case 5:
      var value = /** @type {!proto.common.FilterJoinType} */ (reader.readEnum());
      msg.setJoin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.order_publisher.PublisherWebsiteFilter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.order_publisher.PublisherWebsiteFilter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.order_publisher.PublisherWebsiteFilter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.PublisherWebsiteFilter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrder();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getField();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOperation();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getJoin();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
};


/**
 * optional int32 order = 1;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteFilter.prototype.getOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteFilter} returns this
 */
proto.order_publisher.PublisherWebsiteFilter.prototype.setOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional PublisherWebsiteFilterField field = 2;
 * @return {!proto.order_publisher.PublisherWebsiteFilterField}
 */
proto.order_publisher.PublisherWebsiteFilter.prototype.getField = function() {
  return /** @type {!proto.order_publisher.PublisherWebsiteFilterField} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.order_publisher.PublisherWebsiteFilterField} value
 * @return {!proto.order_publisher.PublisherWebsiteFilter} returns this
 */
proto.order_publisher.PublisherWebsiteFilter.prototype.setField = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string value = 3;
 * @return {string}
 */
proto.order_publisher.PublisherWebsiteFilter.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_publisher.PublisherWebsiteFilter} returns this
 */
proto.order_publisher.PublisherWebsiteFilter.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional common.FilterOperation operation = 4;
 * @return {!proto.common.FilterOperation}
 */
proto.order_publisher.PublisherWebsiteFilter.prototype.getOperation = function() {
  return /** @type {!proto.common.FilterOperation} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.common.FilterOperation} value
 * @return {!proto.order_publisher.PublisherWebsiteFilter} returns this
 */
proto.order_publisher.PublisherWebsiteFilter.prototype.setOperation = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional common.FilterJoinType join = 5;
 * @return {!proto.common.FilterJoinType}
 */
proto.order_publisher.PublisherWebsiteFilter.prototype.getJoin = function() {
  return /** @type {!proto.common.FilterJoinType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.common.FilterJoinType} value
 * @return {!proto.order_publisher.PublisherWebsiteFilter} returns this
 */
proto.order_publisher.PublisherWebsiteFilter.prototype.setJoin = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.order_publisher.PublisherWebsiteResponse.repeatedFields_ = [11];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.order_publisher.PublisherWebsiteResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.order_publisher.PublisherWebsiteResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.order_publisher.PublisherWebsiteResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.PublisherWebsiteResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
domain: jspb.Message.getFieldWithDefault(msg, 2, ""),
name: jspb.Message.getFieldWithDefault(msg, 3, ""),
logo: jspb.Message.getFieldWithDefault(msg, 4, ""),
status: jspb.Message.getFieldWithDefault(msg, 5, 0),
verified: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
verificationType: jspb.Message.getFieldWithDefault(msg, 7, 0),
price: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
linkLimit: jspb.Message.getFieldWithDefault(msg, 9, 0),
qualityScore: jspb.Message.getFieldWithDefault(msg, 10, 0),
languagesList: (f = jspb.Message.getRepeatedField(msg, 11)) == null ? undefined : f,
metrics: (f = msg.getMetrics()) && proto.order_publisher.PublisherWebsiteMetrics.toObject(includeInstance, f),
createdBy: jspb.Message.getFieldWithDefault(msg, 13, 0),
createdAt: jspb.Message.getFieldWithDefault(msg, 14, 0),
totalItems: jspb.Message.getFieldWithDefault(msg, 15, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.order_publisher.PublisherWebsiteResponse}
 */
proto.order_publisher.PublisherWebsiteResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.order_publisher.PublisherWebsiteResponse;
  return proto.order_publisher.PublisherWebsiteResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.order_publisher.PublisherWebsiteResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.order_publisher.PublisherWebsiteResponse}
 */
proto.order_publisher.PublisherWebsiteResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDomain(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLogo(value);
      break;
    case 5:
      var value = /** @type {!proto.common.PublisherWebsiteStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVerified(value);
      break;
    case 7:
      var value = /** @type {!proto.common.PublisherWebsiteVerificationType} */ (reader.readEnum());
      msg.setVerificationType(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPrice(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLinkLimit(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQualityScore(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.addLanguages(value);
      break;
    case 12:
      var value = new proto.order_publisher.PublisherWebsiteMetrics;
      reader.readMessage(value,proto.order_publisher.PublisherWebsiteMetrics.deserializeBinaryFromReader);
      msg.setMetrics(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedBy(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.order_publisher.PublisherWebsiteResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.order_publisher.PublisherWebsiteResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.order_publisher.PublisherWebsiteResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.PublisherWebsiteResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getDomain();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLogo();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getVerified();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getVerificationType();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = message.getLinkLimit();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getQualityScore();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getLanguagesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      11,
      f
    );
  }
  f = message.getMetrics();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.order_publisher.PublisherWebsiteMetrics.serializeBinaryToWriter
    );
  }
  f = message.getCreatedBy();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      14,
      f
    );
  }
  f = message.getTotalItems();
  if (f !== 0) {
    writer.writeInt32(
      15,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteResponse.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteResponse} returns this
 */
proto.order_publisher.PublisherWebsiteResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string domain = 2;
 * @return {string}
 */
proto.order_publisher.PublisherWebsiteResponse.prototype.getDomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_publisher.PublisherWebsiteResponse} returns this
 */
proto.order_publisher.PublisherWebsiteResponse.prototype.setDomain = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.order_publisher.PublisherWebsiteResponse.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_publisher.PublisherWebsiteResponse} returns this
 */
proto.order_publisher.PublisherWebsiteResponse.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string logo = 4;
 * @return {string}
 */
proto.order_publisher.PublisherWebsiteResponse.prototype.getLogo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_publisher.PublisherWebsiteResponse} returns this
 */
proto.order_publisher.PublisherWebsiteResponse.prototype.setLogo = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional common.PublisherWebsiteStatus status = 5;
 * @return {!proto.common.PublisherWebsiteStatus}
 */
proto.order_publisher.PublisherWebsiteResponse.prototype.getStatus = function() {
  return /** @type {!proto.common.PublisherWebsiteStatus} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.common.PublisherWebsiteStatus} value
 * @return {!proto.order_publisher.PublisherWebsiteResponse} returns this
 */
proto.order_publisher.PublisherWebsiteResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional bool verified = 6;
 * @return {boolean}
 */
proto.order_publisher.PublisherWebsiteResponse.prototype.getVerified = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.order_publisher.PublisherWebsiteResponse} returns this
 */
proto.order_publisher.PublisherWebsiteResponse.prototype.setVerified = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional common.PublisherWebsiteVerificationType verification_type = 7;
 * @return {!proto.common.PublisherWebsiteVerificationType}
 */
proto.order_publisher.PublisherWebsiteResponse.prototype.getVerificationType = function() {
  return /** @type {!proto.common.PublisherWebsiteVerificationType} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.common.PublisherWebsiteVerificationType} value
 * @return {!proto.order_publisher.PublisherWebsiteResponse} returns this
 */
proto.order_publisher.PublisherWebsiteResponse.prototype.setVerificationType = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional double price = 8;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteResponse.prototype.getPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteResponse} returns this
 */
proto.order_publisher.PublisherWebsiteResponse.prototype.setPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional int32 link_limit = 9;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteResponse.prototype.getLinkLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteResponse} returns this
 */
proto.order_publisher.PublisherWebsiteResponse.prototype.setLinkLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int32 quality_score = 10;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteResponse.prototype.getQualityScore = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteResponse} returns this
 */
proto.order_publisher.PublisherWebsiteResponse.prototype.setQualityScore = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * repeated string languages = 11;
 * @return {!Array<string>}
 */
proto.order_publisher.PublisherWebsiteResponse.prototype.getLanguagesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 11));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.order_publisher.PublisherWebsiteResponse} returns this
 */
proto.order_publisher.PublisherWebsiteResponse.prototype.setLanguagesList = function(value) {
  return jspb.Message.setField(this, 11, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.order_publisher.PublisherWebsiteResponse} returns this
 */
proto.order_publisher.PublisherWebsiteResponse.prototype.addLanguages = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 11, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.order_publisher.PublisherWebsiteResponse} returns this
 */
proto.order_publisher.PublisherWebsiteResponse.prototype.clearLanguagesList = function() {
  return this.setLanguagesList([]);
};


/**
 * optional PublisherWebsiteMetrics metrics = 12;
 * @return {?proto.order_publisher.PublisherWebsiteMetrics}
 */
proto.order_publisher.PublisherWebsiteResponse.prototype.getMetrics = function() {
  return /** @type{?proto.order_publisher.PublisherWebsiteMetrics} */ (
    jspb.Message.getWrapperField(this, proto.order_publisher.PublisherWebsiteMetrics, 12));
};


/**
 * @param {?proto.order_publisher.PublisherWebsiteMetrics|undefined} value
 * @return {!proto.order_publisher.PublisherWebsiteResponse} returns this
*/
proto.order_publisher.PublisherWebsiteResponse.prototype.setMetrics = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_publisher.PublisherWebsiteResponse} returns this
 */
proto.order_publisher.PublisherWebsiteResponse.prototype.clearMetrics = function() {
  return this.setMetrics(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_publisher.PublisherWebsiteResponse.prototype.hasMetrics = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional int64 created_by = 13;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteResponse.prototype.getCreatedBy = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteResponse} returns this
 */
proto.order_publisher.PublisherWebsiteResponse.prototype.setCreatedBy = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional int64 created_at = 14;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteResponse.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteResponse} returns this
 */
proto.order_publisher.PublisherWebsiteResponse.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int32 total_items = 15;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteResponse.prototype.getTotalItems = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteResponse} returns this
 */
proto.order_publisher.PublisherWebsiteResponse.prototype.setTotalItems = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.repeatedFields_ = [20,21,22,23];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.order_publisher.PublisherWebsiteDetailsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.order_publisher.PublisherWebsiteDetailsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
domain: jspb.Message.getFieldWithDefault(msg, 2, ""),
name: jspb.Message.getFieldWithDefault(msg, 3, ""),
logo: jspb.Message.getFieldWithDefault(msg, 4, ""),
verified: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
status: jspb.Message.getFieldWithDefault(msg, 6, 0),
verificationType: jspb.Message.getFieldWithDefault(msg, 7, 0),
qualityScore: jspb.Message.getFieldWithDefault(msg, 8, 0),
guestPostEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
guestPostPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
guestPostInitPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 11, 0.0),
guestPostLinkPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 12, 0.0),
guestPostLinkInitPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 13, 0.0),
guestPostLinkLimit: jspb.Message.getFieldWithDefault(msg, 14, 0),
guestPostLinkInitLimit: jspb.Message.getFieldWithDefault(msg, 15, 0),
linkInsertionEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 16, false),
linkInsertionPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 17, 0.0),
notes: jspb.Message.getFieldWithDefault(msg, 18, ""),
metrics: (f = msg.getMetrics()) && proto.order_publisher.PublisherWebsiteMetrics.toObject(includeInstance, f),
languagesList: (f = jspb.Message.getRepeatedField(msg, 20)) == null ? undefined : f,
restrictedPricesList: jspb.Message.toObjectList(msg.getRestrictedPricesList(),
    common_pb.PublisherWebsiteRestrictedCategoryPrice.toObject, includeInstance),
verticalsList: (f = jspb.Message.getRepeatedField(msg, 22)) == null ? undefined : f,
typesList: (f = jspb.Message.getRepeatedField(msg, 23)) == null ? undefined : f,
turnaroundTime: jspb.Message.getFieldWithDefault(msg, 24, 0),
articleWordsCountMin: jspb.Message.getFieldWithDefault(msg, 25, 0),
articleWordsCountMax: jspb.Message.getFieldWithDefault(msg, 26, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.order_publisher.PublisherWebsiteDetailsResponse}
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.order_publisher.PublisherWebsiteDetailsResponse;
  return proto.order_publisher.PublisherWebsiteDetailsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.order_publisher.PublisherWebsiteDetailsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.order_publisher.PublisherWebsiteDetailsResponse}
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDomain(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLogo(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVerified(value);
      break;
    case 6:
      var value = /** @type {!proto.common.PublisherWebsiteStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 7:
      var value = /** @type {!proto.common.PublisherWebsiteVerificationType} */ (reader.readEnum());
      msg.setVerificationType(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQualityScore(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setGuestPostEnabled(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setGuestPostPrice(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setGuestPostInitPrice(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setGuestPostLinkPrice(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setGuestPostLinkInitPrice(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setGuestPostLinkLimit(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setGuestPostLinkInitLimit(value);
      break;
    case 16:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLinkInsertionEnabled(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLinkInsertionPrice(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setNotes(value);
      break;
    case 19:
      var value = new proto.order_publisher.PublisherWebsiteMetrics;
      reader.readMessage(value,proto.order_publisher.PublisherWebsiteMetrics.deserializeBinaryFromReader);
      msg.setMetrics(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.addLanguages(value);
      break;
    case 21:
      var value = new common_pb.PublisherWebsiteRestrictedCategoryPrice;
      reader.readMessage(value,common_pb.PublisherWebsiteRestrictedCategoryPrice.deserializeBinaryFromReader);
      msg.addRestrictedPrices(value);
      break;
    case 22:
      var values = /** @type {!Array<!proto.common.OrderItemVertical>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addVerticals(values[i]);
      }
      break;
    case 23:
      var values = /** @type {!Array<!proto.common.PublisherWebsiteType>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addTypes(values[i]);
      }
      break;
    case 24:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTurnaroundTime(value);
      break;
    case 25:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setArticleWordsCountMin(value);
      break;
    case 26:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setArticleWordsCountMax(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.order_publisher.PublisherWebsiteDetailsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.order_publisher.PublisherWebsiteDetailsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getDomain();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLogo();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getVerified();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getVerificationType();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getQualityScore();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getGuestPostEnabled();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getGuestPostPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      10,
      f
    );
  }
  f = message.getGuestPostInitPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      11,
      f
    );
  }
  f = message.getGuestPostLinkPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      12,
      f
    );
  }
  f = message.getGuestPostLinkInitPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      13,
      f
    );
  }
  f = message.getGuestPostLinkLimit();
  if (f !== 0) {
    writer.writeInt32(
      14,
      f
    );
  }
  f = message.getGuestPostLinkInitLimit();
  if (f !== 0) {
    writer.writeInt32(
      15,
      f
    );
  }
  f = message.getLinkInsertionEnabled();
  if (f) {
    writer.writeBool(
      16,
      f
    );
  }
  f = message.getLinkInsertionPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      17,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getMetrics();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      proto.order_publisher.PublisherWebsiteMetrics.serializeBinaryToWriter
    );
  }
  f = message.getLanguagesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      20,
      f
    );
  }
  f = message.getRestrictedPricesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      21,
      f,
      common_pb.PublisherWebsiteRestrictedCategoryPrice.serializeBinaryToWriter
    );
  }
  f = message.getVerticalsList();
  if (f.length > 0) {
    writer.writePackedEnum(
      22,
      f
    );
  }
  f = message.getTypesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      23,
      f
    );
  }
  f = message.getTurnaroundTime();
  if (f !== 0) {
    writer.writeInt32(
      24,
      f
    );
  }
  f = message.getArticleWordsCountMin();
  if (f !== 0) {
    writer.writeInt32(
      25,
      f
    );
  }
  f = message.getArticleWordsCountMax();
  if (f !== 0) {
    writer.writeInt32(
      26,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteDetailsResponse} returns this
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string domain = 2;
 * @return {string}
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.getDomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_publisher.PublisherWebsiteDetailsResponse} returns this
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.setDomain = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_publisher.PublisherWebsiteDetailsResponse} returns this
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string logo = 4;
 * @return {string}
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.getLogo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_publisher.PublisherWebsiteDetailsResponse} returns this
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.setLogo = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool verified = 5;
 * @return {boolean}
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.getVerified = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.order_publisher.PublisherWebsiteDetailsResponse} returns this
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.setVerified = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional common.PublisherWebsiteStatus status = 6;
 * @return {!proto.common.PublisherWebsiteStatus}
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.getStatus = function() {
  return /** @type {!proto.common.PublisherWebsiteStatus} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.common.PublisherWebsiteStatus} value
 * @return {!proto.order_publisher.PublisherWebsiteDetailsResponse} returns this
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional common.PublisherWebsiteVerificationType verification_type = 7;
 * @return {!proto.common.PublisherWebsiteVerificationType}
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.getVerificationType = function() {
  return /** @type {!proto.common.PublisherWebsiteVerificationType} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.common.PublisherWebsiteVerificationType} value
 * @return {!proto.order_publisher.PublisherWebsiteDetailsResponse} returns this
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.setVerificationType = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional int32 quality_score = 8;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.getQualityScore = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteDetailsResponse} returns this
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.setQualityScore = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional bool guest_post_enabled = 9;
 * @return {boolean}
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.getGuestPostEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.order_publisher.PublisherWebsiteDetailsResponse} returns this
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.setGuestPostEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional double guest_post_price = 10;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.getGuestPostPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteDetailsResponse} returns this
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.setGuestPostPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};


/**
 * optional double guest_post_init_price = 11;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.getGuestPostInitPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteDetailsResponse} returns this
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.setGuestPostInitPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 11, value);
};


/**
 * optional double guest_post_link_price = 12;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.getGuestPostLinkPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 12, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteDetailsResponse} returns this
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.setGuestPostLinkPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 12, value);
};


/**
 * optional double guest_post_link_init_price = 13;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.getGuestPostLinkInitPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 13, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteDetailsResponse} returns this
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.setGuestPostLinkInitPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 13, value);
};


/**
 * optional int32 guest_post_link_limit = 14;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.getGuestPostLinkLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteDetailsResponse} returns this
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.setGuestPostLinkLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int32 guest_post_link_init_limit = 15;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.getGuestPostLinkInitLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteDetailsResponse} returns this
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.setGuestPostLinkInitLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional bool link_insertion_enabled = 16;
 * @return {boolean}
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.getLinkInsertionEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 16, false));
};


/**
 * @param {boolean} value
 * @return {!proto.order_publisher.PublisherWebsiteDetailsResponse} returns this
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.setLinkInsertionEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 16, value);
};


/**
 * optional double link_insertion_price = 17;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.getLinkInsertionPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 17, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteDetailsResponse} returns this
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.setLinkInsertionPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 17, value);
};


/**
 * optional string notes = 18;
 * @return {string}
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_publisher.PublisherWebsiteDetailsResponse} returns this
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional PublisherWebsiteMetrics metrics = 19;
 * @return {?proto.order_publisher.PublisherWebsiteMetrics}
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.getMetrics = function() {
  return /** @type{?proto.order_publisher.PublisherWebsiteMetrics} */ (
    jspb.Message.getWrapperField(this, proto.order_publisher.PublisherWebsiteMetrics, 19));
};


/**
 * @param {?proto.order_publisher.PublisherWebsiteMetrics|undefined} value
 * @return {!proto.order_publisher.PublisherWebsiteDetailsResponse} returns this
*/
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.setMetrics = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_publisher.PublisherWebsiteDetailsResponse} returns this
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.clearMetrics = function() {
  return this.setMetrics(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.hasMetrics = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * repeated string languages = 20;
 * @return {!Array<string>}
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.getLanguagesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 20));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.order_publisher.PublisherWebsiteDetailsResponse} returns this
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.setLanguagesList = function(value) {
  return jspb.Message.setField(this, 20, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.order_publisher.PublisherWebsiteDetailsResponse} returns this
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.addLanguages = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 20, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.order_publisher.PublisherWebsiteDetailsResponse} returns this
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.clearLanguagesList = function() {
  return this.setLanguagesList([]);
};


/**
 * repeated common.PublisherWebsiteRestrictedCategoryPrice restricted_prices = 21;
 * @return {!Array<!proto.common.PublisherWebsiteRestrictedCategoryPrice>}
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.getRestrictedPricesList = function() {
  return /** @type{!Array<!proto.common.PublisherWebsiteRestrictedCategoryPrice>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.PublisherWebsiteRestrictedCategoryPrice, 21));
};


/**
 * @param {!Array<!proto.common.PublisherWebsiteRestrictedCategoryPrice>} value
 * @return {!proto.order_publisher.PublisherWebsiteDetailsResponse} returns this
*/
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.setRestrictedPricesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 21, value);
};


/**
 * @param {!proto.common.PublisherWebsiteRestrictedCategoryPrice=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.PublisherWebsiteRestrictedCategoryPrice}
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.addRestrictedPrices = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 21, opt_value, proto.common.PublisherWebsiteRestrictedCategoryPrice, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.order_publisher.PublisherWebsiteDetailsResponse} returns this
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.clearRestrictedPricesList = function() {
  return this.setRestrictedPricesList([]);
};


/**
 * repeated common.OrderItemVertical verticals = 22;
 * @return {!Array<!proto.common.OrderItemVertical>}
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.getVerticalsList = function() {
  return /** @type {!Array<!proto.common.OrderItemVertical>} */ (jspb.Message.getRepeatedField(this, 22));
};


/**
 * @param {!Array<!proto.common.OrderItemVertical>} value
 * @return {!proto.order_publisher.PublisherWebsiteDetailsResponse} returns this
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.setVerticalsList = function(value) {
  return jspb.Message.setField(this, 22, value || []);
};


/**
 * @param {!proto.common.OrderItemVertical} value
 * @param {number=} opt_index
 * @return {!proto.order_publisher.PublisherWebsiteDetailsResponse} returns this
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.addVerticals = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 22, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.order_publisher.PublisherWebsiteDetailsResponse} returns this
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.clearVerticalsList = function() {
  return this.setVerticalsList([]);
};


/**
 * repeated common.PublisherWebsiteType types = 23;
 * @return {!Array<!proto.common.PublisherWebsiteType>}
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.getTypesList = function() {
  return /** @type {!Array<!proto.common.PublisherWebsiteType>} */ (jspb.Message.getRepeatedField(this, 23));
};


/**
 * @param {!Array<!proto.common.PublisherWebsiteType>} value
 * @return {!proto.order_publisher.PublisherWebsiteDetailsResponse} returns this
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.setTypesList = function(value) {
  return jspb.Message.setField(this, 23, value || []);
};


/**
 * @param {!proto.common.PublisherWebsiteType} value
 * @param {number=} opt_index
 * @return {!proto.order_publisher.PublisherWebsiteDetailsResponse} returns this
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.addTypes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 23, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.order_publisher.PublisherWebsiteDetailsResponse} returns this
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.clearTypesList = function() {
  return this.setTypesList([]);
};


/**
 * optional int32 turnaround_time = 24;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.getTurnaroundTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 24, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteDetailsResponse} returns this
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.setTurnaroundTime = function(value) {
  return jspb.Message.setProto3IntField(this, 24, value);
};


/**
 * optional int32 article_words_count_min = 25;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.getArticleWordsCountMin = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 25, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteDetailsResponse} returns this
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.setArticleWordsCountMin = function(value) {
  return jspb.Message.setProto3IntField(this, 25, value);
};


/**
 * optional int32 article_words_count_max = 26;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.getArticleWordsCountMax = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 26, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteDetailsResponse} returns this
 */
proto.order_publisher.PublisherWebsiteDetailsResponse.prototype.setArticleWordsCountMax = function(value) {
  return jspb.Message.setProto3IntField(this, 26, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.order_publisher.PublisherWebsiteChangeStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.order_publisher.PublisherWebsiteChangeStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.order_publisher.PublisherWebsiteChangeStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.PublisherWebsiteChangeStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
workspaceId: jspb.Message.getFieldWithDefault(msg, 2, 0),
status: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.order_publisher.PublisherWebsiteChangeStatusRequest}
 */
proto.order_publisher.PublisherWebsiteChangeStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.order_publisher.PublisherWebsiteChangeStatusRequest;
  return proto.order_publisher.PublisherWebsiteChangeStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.order_publisher.PublisherWebsiteChangeStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.order_publisher.PublisherWebsiteChangeStatusRequest}
 */
proto.order_publisher.PublisherWebsiteChangeStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    case 3:
      var value = /** @type {!proto.common.PublisherWebsiteStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.order_publisher.PublisherWebsiteChangeStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.order_publisher.PublisherWebsiteChangeStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.order_publisher.PublisherWebsiteChangeStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.PublisherWebsiteChangeStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteChangeStatusRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteChangeStatusRequest} returns this
 */
proto.order_publisher.PublisherWebsiteChangeStatusRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 workspace_id = 2;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteChangeStatusRequest.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteChangeStatusRequest} returns this
 */
proto.order_publisher.PublisherWebsiteChangeStatusRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional common.PublisherWebsiteStatus status = 3;
 * @return {!proto.common.PublisherWebsiteStatus}
 */
proto.order_publisher.PublisherWebsiteChangeStatusRequest.prototype.getStatus = function() {
  return /** @type {!proto.common.PublisherWebsiteStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.common.PublisherWebsiteStatus} value
 * @return {!proto.order_publisher.PublisherWebsiteChangeStatusRequest} returns this
 */
proto.order_publisher.PublisherWebsiteChangeStatusRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.order_publisher.PublisherWebsiteMetrics.prototype.toObject = function(opt_includeInstance) {
  return proto.order_publisher.PublisherWebsiteMetrics.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.order_publisher.PublisherWebsiteMetrics} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.PublisherWebsiteMetrics.toObject = function(includeInstance, msg) {
  var f, obj = {
ahrefRating: jspb.Message.getFieldWithDefault(msg, 1, 0),
mozAuthority: jspb.Message.getFieldWithDefault(msg, 2, 0),
semrushRank: jspb.Message.getFieldWithDefault(msg, 3, 0),
topCountry: jspb.Message.getFieldWithDefault(msg, 4, ""),
countryPercentage: jspb.Message.getFieldWithDefault(msg, 5, 0),
keywords: jspb.Message.getFieldWithDefault(msg, 6, 0),
refDomains: jspb.Message.getFieldWithDefault(msg, 7, 0),
traffic: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.order_publisher.PublisherWebsiteMetrics}
 */
proto.order_publisher.PublisherWebsiteMetrics.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.order_publisher.PublisherWebsiteMetrics;
  return proto.order_publisher.PublisherWebsiteMetrics.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.order_publisher.PublisherWebsiteMetrics} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.order_publisher.PublisherWebsiteMetrics}
 */
proto.order_publisher.PublisherWebsiteMetrics.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAhrefRating(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMozAuthority(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSemrushRank(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTopCountry(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCountryPercentage(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setKeywords(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRefDomains(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTraffic(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.order_publisher.PublisherWebsiteMetrics.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.order_publisher.PublisherWebsiteMetrics.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.order_publisher.PublisherWebsiteMetrics} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.PublisherWebsiteMetrics.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAhrefRating();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getMozAuthority();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getSemrushRank();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTopCountry();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCountryPercentage();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getKeywords();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getRefDomains();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getTraffic();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
};


/**
 * optional int32 ahref_rating = 1;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteMetrics.prototype.getAhrefRating = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteMetrics} returns this
 */
proto.order_publisher.PublisherWebsiteMetrics.prototype.setAhrefRating = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 moz_authority = 2;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteMetrics.prototype.getMozAuthority = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteMetrics} returns this
 */
proto.order_publisher.PublisherWebsiteMetrics.prototype.setMozAuthority = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 semrush_rank = 3;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteMetrics.prototype.getSemrushRank = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteMetrics} returns this
 */
proto.order_publisher.PublisherWebsiteMetrics.prototype.setSemrushRank = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string top_country = 4;
 * @return {string}
 */
proto.order_publisher.PublisherWebsiteMetrics.prototype.getTopCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_publisher.PublisherWebsiteMetrics} returns this
 */
proto.order_publisher.PublisherWebsiteMetrics.prototype.setTopCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 country_percentage = 5;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteMetrics.prototype.getCountryPercentage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteMetrics} returns this
 */
proto.order_publisher.PublisherWebsiteMetrics.prototype.setCountryPercentage = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 keywords = 6;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteMetrics.prototype.getKeywords = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteMetrics} returns this
 */
proto.order_publisher.PublisherWebsiteMetrics.prototype.setKeywords = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 ref_domains = 7;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteMetrics.prototype.getRefDomains = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteMetrics} returns this
 */
proto.order_publisher.PublisherWebsiteMetrics.prototype.setRefDomains = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 traffic = 8;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteMetrics.prototype.getTraffic = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteMetrics} returns this
 */
proto.order_publisher.PublisherWebsiteMetrics.prototype.setTraffic = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.order_publisher.PublisherWebsiteCreateRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.order_publisher.PublisherWebsiteCreateRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.order_publisher.PublisherWebsiteCreateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.PublisherWebsiteCreateRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
workspaceId: jspb.Message.getFieldWithDefault(msg, 1, 0),
domain: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.order_publisher.PublisherWebsiteCreateRequest}
 */
proto.order_publisher.PublisherWebsiteCreateRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.order_publisher.PublisherWebsiteCreateRequest;
  return proto.order_publisher.PublisherWebsiteCreateRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.order_publisher.PublisherWebsiteCreateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.order_publisher.PublisherWebsiteCreateRequest}
 */
proto.order_publisher.PublisherWebsiteCreateRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDomain(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.order_publisher.PublisherWebsiteCreateRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.order_publisher.PublisherWebsiteCreateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.order_publisher.PublisherWebsiteCreateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.PublisherWebsiteCreateRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getDomain();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int64 workspace_id = 1;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteCreateRequest.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteCreateRequest} returns this
 */
proto.order_publisher.PublisherWebsiteCreateRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string domain = 2;
 * @return {string}
 */
proto.order_publisher.PublisherWebsiteCreateRequest.prototype.getDomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_publisher.PublisherWebsiteCreateRequest} returns this
 */
proto.order_publisher.PublisherWebsiteCreateRequest.prototype.setDomain = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.order_publisher.PublisherWebsiteUpdateRequest.repeatedFields_ = [10,11,12,13];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.order_publisher.PublisherWebsiteUpdateRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.order_publisher.PublisherWebsiteUpdateRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.order_publisher.PublisherWebsiteUpdateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.PublisherWebsiteUpdateRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
workspaceId: jspb.Message.getFieldWithDefault(msg, 2, 0),
guestPostEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
guestPostPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
guestPostLinkPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
guestPostLinkLimit: jspb.Message.getFieldWithDefault(msg, 6, 0),
linkInsertionEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
linkInsertionPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
notes: jspb.Message.getFieldWithDefault(msg, 9, ""),
languagesList: (f = jspb.Message.getRepeatedField(msg, 10)) == null ? undefined : f,
verticalsList: (f = jspb.Message.getRepeatedField(msg, 11)) == null ? undefined : f,
restrictedPricesList: jspb.Message.toObjectList(msg.getRestrictedPricesList(),
    common_pb.PublisherWebsiteRestrictedCategoryPrice.toObject, includeInstance),
typesList: (f = jspb.Message.getRepeatedField(msg, 13)) == null ? undefined : f,
turnaroundTime: jspb.Message.getFieldWithDefault(msg, 14, 0),
articleWordsCountMin: jspb.Message.getFieldWithDefault(msg, 15, 0),
articleWordsCountMax: jspb.Message.getFieldWithDefault(msg, 16, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.order_publisher.PublisherWebsiteUpdateRequest}
 */
proto.order_publisher.PublisherWebsiteUpdateRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.order_publisher.PublisherWebsiteUpdateRequest;
  return proto.order_publisher.PublisherWebsiteUpdateRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.order_publisher.PublisherWebsiteUpdateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.order_publisher.PublisherWebsiteUpdateRequest}
 */
proto.order_publisher.PublisherWebsiteUpdateRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setGuestPostEnabled(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setGuestPostPrice(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setGuestPostLinkPrice(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setGuestPostLinkLimit(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLinkInsertionEnabled(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLinkInsertionPrice(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setNotes(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.addLanguages(value);
      break;
    case 11:
      var values = /** @type {!Array<!proto.common.OrderItemVertical>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addVerticals(values[i]);
      }
      break;
    case 12:
      var value = new common_pb.PublisherWebsiteRestrictedCategoryPrice;
      reader.readMessage(value,common_pb.PublisherWebsiteRestrictedCategoryPrice.deserializeBinaryFromReader);
      msg.addRestrictedPrices(value);
      break;
    case 13:
      var values = /** @type {!Array<!proto.common.PublisherWebsiteType>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addTypes(values[i]);
      }
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTurnaroundTime(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setArticleWordsCountMin(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setArticleWordsCountMax(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.order_publisher.PublisherWebsiteUpdateRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.order_publisher.PublisherWebsiteUpdateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.order_publisher.PublisherWebsiteUpdateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.PublisherWebsiteUpdateRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getGuestPostEnabled();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getGuestPostPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getGuestPostLinkPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getGuestPostLinkLimit();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getLinkInsertionEnabled();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getLinkInsertionPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getLanguagesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      10,
      f
    );
  }
  f = message.getVerticalsList();
  if (f.length > 0) {
    writer.writePackedEnum(
      11,
      f
    );
  }
  f = message.getRestrictedPricesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      12,
      f,
      common_pb.PublisherWebsiteRestrictedCategoryPrice.serializeBinaryToWriter
    );
  }
  f = message.getTypesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      13,
      f
    );
  }
  f = message.getTurnaroundTime();
  if (f !== 0) {
    writer.writeInt32(
      14,
      f
    );
  }
  f = message.getArticleWordsCountMin();
  if (f !== 0) {
    writer.writeInt32(
      15,
      f
    );
  }
  f = message.getArticleWordsCountMax();
  if (f !== 0) {
    writer.writeInt32(
      16,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteUpdateRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteUpdateRequest} returns this
 */
proto.order_publisher.PublisherWebsiteUpdateRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 workspace_id = 2;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteUpdateRequest.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteUpdateRequest} returns this
 */
proto.order_publisher.PublisherWebsiteUpdateRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional bool guest_post_enabled = 3;
 * @return {boolean}
 */
proto.order_publisher.PublisherWebsiteUpdateRequest.prototype.getGuestPostEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.order_publisher.PublisherWebsiteUpdateRequest} returns this
 */
proto.order_publisher.PublisherWebsiteUpdateRequest.prototype.setGuestPostEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional double guest_post_price = 4;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteUpdateRequest.prototype.getGuestPostPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteUpdateRequest} returns this
 */
proto.order_publisher.PublisherWebsiteUpdateRequest.prototype.setGuestPostPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double guest_post_link_price = 5;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteUpdateRequest.prototype.getGuestPostLinkPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteUpdateRequest} returns this
 */
proto.order_publisher.PublisherWebsiteUpdateRequest.prototype.setGuestPostLinkPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional int32 guest_post_link_limit = 6;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteUpdateRequest.prototype.getGuestPostLinkLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteUpdateRequest} returns this
 */
proto.order_publisher.PublisherWebsiteUpdateRequest.prototype.setGuestPostLinkLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional bool link_insertion_enabled = 7;
 * @return {boolean}
 */
proto.order_publisher.PublisherWebsiteUpdateRequest.prototype.getLinkInsertionEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.order_publisher.PublisherWebsiteUpdateRequest} returns this
 */
proto.order_publisher.PublisherWebsiteUpdateRequest.prototype.setLinkInsertionEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional double link_insertion_price = 8;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteUpdateRequest.prototype.getLinkInsertionPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteUpdateRequest} returns this
 */
proto.order_publisher.PublisherWebsiteUpdateRequest.prototype.setLinkInsertionPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional string notes = 9;
 * @return {string}
 */
proto.order_publisher.PublisherWebsiteUpdateRequest.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_publisher.PublisherWebsiteUpdateRequest} returns this
 */
proto.order_publisher.PublisherWebsiteUpdateRequest.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * repeated string languages = 10;
 * @return {!Array<string>}
 */
proto.order_publisher.PublisherWebsiteUpdateRequest.prototype.getLanguagesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 10));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.order_publisher.PublisherWebsiteUpdateRequest} returns this
 */
proto.order_publisher.PublisherWebsiteUpdateRequest.prototype.setLanguagesList = function(value) {
  return jspb.Message.setField(this, 10, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.order_publisher.PublisherWebsiteUpdateRequest} returns this
 */
proto.order_publisher.PublisherWebsiteUpdateRequest.prototype.addLanguages = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 10, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.order_publisher.PublisherWebsiteUpdateRequest} returns this
 */
proto.order_publisher.PublisherWebsiteUpdateRequest.prototype.clearLanguagesList = function() {
  return this.setLanguagesList([]);
};


/**
 * repeated common.OrderItemVertical verticals = 11;
 * @return {!Array<!proto.common.OrderItemVertical>}
 */
proto.order_publisher.PublisherWebsiteUpdateRequest.prototype.getVerticalsList = function() {
  return /** @type {!Array<!proto.common.OrderItemVertical>} */ (jspb.Message.getRepeatedField(this, 11));
};


/**
 * @param {!Array<!proto.common.OrderItemVertical>} value
 * @return {!proto.order_publisher.PublisherWebsiteUpdateRequest} returns this
 */
proto.order_publisher.PublisherWebsiteUpdateRequest.prototype.setVerticalsList = function(value) {
  return jspb.Message.setField(this, 11, value || []);
};


/**
 * @param {!proto.common.OrderItemVertical} value
 * @param {number=} opt_index
 * @return {!proto.order_publisher.PublisherWebsiteUpdateRequest} returns this
 */
proto.order_publisher.PublisherWebsiteUpdateRequest.prototype.addVerticals = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 11, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.order_publisher.PublisherWebsiteUpdateRequest} returns this
 */
proto.order_publisher.PublisherWebsiteUpdateRequest.prototype.clearVerticalsList = function() {
  return this.setVerticalsList([]);
};


/**
 * repeated common.PublisherWebsiteRestrictedCategoryPrice restricted_prices = 12;
 * @return {!Array<!proto.common.PublisherWebsiteRestrictedCategoryPrice>}
 */
proto.order_publisher.PublisherWebsiteUpdateRequest.prototype.getRestrictedPricesList = function() {
  return /** @type{!Array<!proto.common.PublisherWebsiteRestrictedCategoryPrice>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.PublisherWebsiteRestrictedCategoryPrice, 12));
};


/**
 * @param {!Array<!proto.common.PublisherWebsiteRestrictedCategoryPrice>} value
 * @return {!proto.order_publisher.PublisherWebsiteUpdateRequest} returns this
*/
proto.order_publisher.PublisherWebsiteUpdateRequest.prototype.setRestrictedPricesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 12, value);
};


/**
 * @param {!proto.common.PublisherWebsiteRestrictedCategoryPrice=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.PublisherWebsiteRestrictedCategoryPrice}
 */
proto.order_publisher.PublisherWebsiteUpdateRequest.prototype.addRestrictedPrices = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 12, opt_value, proto.common.PublisherWebsiteRestrictedCategoryPrice, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.order_publisher.PublisherWebsiteUpdateRequest} returns this
 */
proto.order_publisher.PublisherWebsiteUpdateRequest.prototype.clearRestrictedPricesList = function() {
  return this.setRestrictedPricesList([]);
};


/**
 * repeated common.PublisherWebsiteType types = 13;
 * @return {!Array<!proto.common.PublisherWebsiteType>}
 */
proto.order_publisher.PublisherWebsiteUpdateRequest.prototype.getTypesList = function() {
  return /** @type {!Array<!proto.common.PublisherWebsiteType>} */ (jspb.Message.getRepeatedField(this, 13));
};


/**
 * @param {!Array<!proto.common.PublisherWebsiteType>} value
 * @return {!proto.order_publisher.PublisherWebsiteUpdateRequest} returns this
 */
proto.order_publisher.PublisherWebsiteUpdateRequest.prototype.setTypesList = function(value) {
  return jspb.Message.setField(this, 13, value || []);
};


/**
 * @param {!proto.common.PublisherWebsiteType} value
 * @param {number=} opt_index
 * @return {!proto.order_publisher.PublisherWebsiteUpdateRequest} returns this
 */
proto.order_publisher.PublisherWebsiteUpdateRequest.prototype.addTypes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 13, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.order_publisher.PublisherWebsiteUpdateRequest} returns this
 */
proto.order_publisher.PublisherWebsiteUpdateRequest.prototype.clearTypesList = function() {
  return this.setTypesList([]);
};


/**
 * optional int32 turnaround_time = 14;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteUpdateRequest.prototype.getTurnaroundTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteUpdateRequest} returns this
 */
proto.order_publisher.PublisherWebsiteUpdateRequest.prototype.setTurnaroundTime = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int32 article_words_count_min = 15;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteUpdateRequest.prototype.getArticleWordsCountMin = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteUpdateRequest} returns this
 */
proto.order_publisher.PublisherWebsiteUpdateRequest.prototype.setArticleWordsCountMin = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional int32 article_words_count_max = 16;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteUpdateRequest.prototype.getArticleWordsCountMax = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteUpdateRequest} returns this
 */
proto.order_publisher.PublisherWebsiteUpdateRequest.prototype.setArticleWordsCountMax = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.order_publisher.PublisherWebsiteCalcPriceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.order_publisher.PublisherWebsiteCalcPriceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.order_publisher.PublisherWebsiteCalcPriceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.PublisherWebsiteCalcPriceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
workspaceId: jspb.Message.getFieldWithDefault(msg, 2, 0),
guestPostLinkLimit: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.order_publisher.PublisherWebsiteCalcPriceRequest}
 */
proto.order_publisher.PublisherWebsiteCalcPriceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.order_publisher.PublisherWebsiteCalcPriceRequest;
  return proto.order_publisher.PublisherWebsiteCalcPriceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.order_publisher.PublisherWebsiteCalcPriceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.order_publisher.PublisherWebsiteCalcPriceRequest}
 */
proto.order_publisher.PublisherWebsiteCalcPriceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setGuestPostLinkLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.order_publisher.PublisherWebsiteCalcPriceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.order_publisher.PublisherWebsiteCalcPriceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.order_publisher.PublisherWebsiteCalcPriceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.PublisherWebsiteCalcPriceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getGuestPostLinkLimit();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteCalcPriceRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteCalcPriceRequest} returns this
 */
proto.order_publisher.PublisherWebsiteCalcPriceRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 workspace_id = 2;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteCalcPriceRequest.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteCalcPriceRequest} returns this
 */
proto.order_publisher.PublisherWebsiteCalcPriceRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 guest_post_link_limit = 3;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteCalcPriceRequest.prototype.getGuestPostLinkLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteCalcPriceRequest} returns this
 */
proto.order_publisher.PublisherWebsiteCalcPriceRequest.prototype.setGuestPostLinkLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.order_publisher.PublisherWebsiteCalcPriceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.order_publisher.PublisherWebsiteCalcPriceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.order_publisher.PublisherWebsiteCalcPriceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.PublisherWebsiteCalcPriceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
suggestedPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
reason: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.order_publisher.PublisherWebsiteCalcPriceResponse}
 */
proto.order_publisher.PublisherWebsiteCalcPriceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.order_publisher.PublisherWebsiteCalcPriceResponse;
  return proto.order_publisher.PublisherWebsiteCalcPriceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.order_publisher.PublisherWebsiteCalcPriceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.order_publisher.PublisherWebsiteCalcPriceResponse}
 */
proto.order_publisher.PublisherWebsiteCalcPriceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSuggestedPrice(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.order_publisher.PublisherWebsiteCalcPriceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.order_publisher.PublisherWebsiteCalcPriceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.order_publisher.PublisherWebsiteCalcPriceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.PublisherWebsiteCalcPriceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuggestedPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getReason();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional double suggested_price = 1;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteCalcPriceResponse.prototype.getSuggestedPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteCalcPriceResponse} returns this
 */
proto.order_publisher.PublisherWebsiteCalcPriceResponse.prototype.setSuggestedPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional string reason = 2;
 * @return {string}
 */
proto.order_publisher.PublisherWebsiteCalcPriceResponse.prototype.getReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_publisher.PublisherWebsiteCalcPriceResponse} returns this
 */
proto.order_publisher.PublisherWebsiteCalcPriceResponse.prototype.setReason = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.order_publisher.PublisherWebsiteVerificationContainer.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.order_publisher.PublisherWebsiteVerificationContainer.prototype.toObject = function(opt_includeInstance) {
  return proto.order_publisher.PublisherWebsiteVerificationContainer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.order_publisher.PublisherWebsiteVerificationContainer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.PublisherWebsiteVerificationContainer.toObject = function(includeInstance, msg) {
  var f, obj = {
optionsList: jspb.Message.toObjectList(msg.getOptionsList(),
    proto.order_publisher.PublisherWebsiteVerificationOption.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.order_publisher.PublisherWebsiteVerificationContainer}
 */
proto.order_publisher.PublisherWebsiteVerificationContainer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.order_publisher.PublisherWebsiteVerificationContainer;
  return proto.order_publisher.PublisherWebsiteVerificationContainer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.order_publisher.PublisherWebsiteVerificationContainer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.order_publisher.PublisherWebsiteVerificationContainer}
 */
proto.order_publisher.PublisherWebsiteVerificationContainer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.order_publisher.PublisherWebsiteVerificationOption;
      reader.readMessage(value,proto.order_publisher.PublisherWebsiteVerificationOption.deserializeBinaryFromReader);
      msg.addOptions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.order_publisher.PublisherWebsiteVerificationContainer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.order_publisher.PublisherWebsiteVerificationContainer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.order_publisher.PublisherWebsiteVerificationContainer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.PublisherWebsiteVerificationContainer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.order_publisher.PublisherWebsiteVerificationOption.serializeBinaryToWriter
    );
  }
};


/**
 * repeated PublisherWebsiteVerificationOption options = 1;
 * @return {!Array<!proto.order_publisher.PublisherWebsiteVerificationOption>}
 */
proto.order_publisher.PublisherWebsiteVerificationContainer.prototype.getOptionsList = function() {
  return /** @type{!Array<!proto.order_publisher.PublisherWebsiteVerificationOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.order_publisher.PublisherWebsiteVerificationOption, 1));
};


/**
 * @param {!Array<!proto.order_publisher.PublisherWebsiteVerificationOption>} value
 * @return {!proto.order_publisher.PublisherWebsiteVerificationContainer} returns this
*/
proto.order_publisher.PublisherWebsiteVerificationContainer.prototype.setOptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.order_publisher.PublisherWebsiteVerificationOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.order_publisher.PublisherWebsiteVerificationOption}
 */
proto.order_publisher.PublisherWebsiteVerificationContainer.prototype.addOptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.order_publisher.PublisherWebsiteVerificationOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.order_publisher.PublisherWebsiteVerificationContainer} returns this
 */
proto.order_publisher.PublisherWebsiteVerificationContainer.prototype.clearOptionsList = function() {
  return this.setOptionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.order_publisher.PublisherWebsiteVerificationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.order_publisher.PublisherWebsiteVerificationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.order_publisher.PublisherWebsiteVerificationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.PublisherWebsiteVerificationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
websiteId: jspb.Message.getFieldWithDefault(msg, 1, 0),
type: jspb.Message.getFieldWithDefault(msg, 2, 0),
optGoogleToken: jspb.Message.getFieldWithDefault(msg, 3, ""),
optEmail: jspb.Message.getFieldWithDefault(msg, 4, ""),
optVerificationCode: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.order_publisher.PublisherWebsiteVerificationRequest}
 */
proto.order_publisher.PublisherWebsiteVerificationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.order_publisher.PublisherWebsiteVerificationRequest;
  return proto.order_publisher.PublisherWebsiteVerificationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.order_publisher.PublisherWebsiteVerificationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.order_publisher.PublisherWebsiteVerificationRequest}
 */
proto.order_publisher.PublisherWebsiteVerificationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWebsiteId(value);
      break;
    case 2:
      var value = /** @type {!proto.common.PublisherWebsiteVerificationType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOptGoogleToken(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOptEmail(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setOptVerificationCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.order_publisher.PublisherWebsiteVerificationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.order_publisher.PublisherWebsiteVerificationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.order_publisher.PublisherWebsiteVerificationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.PublisherWebsiteVerificationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWebsiteId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getOptGoogleToken();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOptEmail();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getOptVerificationCode();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional int64 website_id = 1;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteVerificationRequest.prototype.getWebsiteId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteVerificationRequest} returns this
 */
proto.order_publisher.PublisherWebsiteVerificationRequest.prototype.setWebsiteId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional common.PublisherWebsiteVerificationType type = 2;
 * @return {!proto.common.PublisherWebsiteVerificationType}
 */
proto.order_publisher.PublisherWebsiteVerificationRequest.prototype.getType = function() {
  return /** @type {!proto.common.PublisherWebsiteVerificationType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.common.PublisherWebsiteVerificationType} value
 * @return {!proto.order_publisher.PublisherWebsiteVerificationRequest} returns this
 */
proto.order_publisher.PublisherWebsiteVerificationRequest.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string opt_google_token = 3;
 * @return {string}
 */
proto.order_publisher.PublisherWebsiteVerificationRequest.prototype.getOptGoogleToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_publisher.PublisherWebsiteVerificationRequest} returns this
 */
proto.order_publisher.PublisherWebsiteVerificationRequest.prototype.setOptGoogleToken = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string opt_email = 4;
 * @return {string}
 */
proto.order_publisher.PublisherWebsiteVerificationRequest.prototype.getOptEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_publisher.PublisherWebsiteVerificationRequest} returns this
 */
proto.order_publisher.PublisherWebsiteVerificationRequest.prototype.setOptEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string opt_verification_code = 5;
 * @return {string}
 */
proto.order_publisher.PublisherWebsiteVerificationRequest.prototype.getOptVerificationCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_publisher.PublisherWebsiteVerificationRequest} returns this
 */
proto.order_publisher.PublisherWebsiteVerificationRequest.prototype.setOptVerificationCode = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.order_publisher.PublisherWebsiteSendVerificationEmailRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.order_publisher.PublisherWebsiteSendVerificationEmailRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.order_publisher.PublisherWebsiteSendVerificationEmailRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.PublisherWebsiteSendVerificationEmailRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
websiteId: jspb.Message.getFieldWithDefault(msg, 1, 0),
email: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.order_publisher.PublisherWebsiteSendVerificationEmailRequest}
 */
proto.order_publisher.PublisherWebsiteSendVerificationEmailRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.order_publisher.PublisherWebsiteSendVerificationEmailRequest;
  return proto.order_publisher.PublisherWebsiteSendVerificationEmailRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.order_publisher.PublisherWebsiteSendVerificationEmailRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.order_publisher.PublisherWebsiteSendVerificationEmailRequest}
 */
proto.order_publisher.PublisherWebsiteSendVerificationEmailRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWebsiteId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.order_publisher.PublisherWebsiteSendVerificationEmailRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.order_publisher.PublisherWebsiteSendVerificationEmailRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.order_publisher.PublisherWebsiteSendVerificationEmailRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.PublisherWebsiteSendVerificationEmailRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWebsiteId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int64 website_id = 1;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteSendVerificationEmailRequest.prototype.getWebsiteId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteSendVerificationEmailRequest} returns this
 */
proto.order_publisher.PublisherWebsiteSendVerificationEmailRequest.prototype.setWebsiteId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.order_publisher.PublisherWebsiteSendVerificationEmailRequest.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_publisher.PublisherWebsiteSendVerificationEmailRequest} returns this
 */
proto.order_publisher.PublisherWebsiteSendVerificationEmailRequest.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.order_publisher.PublisherWebsiteImportLaunchRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.order_publisher.PublisherWebsiteImportLaunchRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.order_publisher.PublisherWebsiteImportLaunchRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.PublisherWebsiteImportLaunchRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
workspaceId: jspb.Message.getFieldWithDefault(msg, 1, 0),
fileUid: jspb.Message.getFieldWithDefault(msg, 2, ""),
fileName: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.order_publisher.PublisherWebsiteImportLaunchRequest}
 */
proto.order_publisher.PublisherWebsiteImportLaunchRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.order_publisher.PublisherWebsiteImportLaunchRequest;
  return proto.order_publisher.PublisherWebsiteImportLaunchRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.order_publisher.PublisherWebsiteImportLaunchRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.order_publisher.PublisherWebsiteImportLaunchRequest}
 */
proto.order_publisher.PublisherWebsiteImportLaunchRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileUid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.order_publisher.PublisherWebsiteImportLaunchRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.order_publisher.PublisherWebsiteImportLaunchRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.order_publisher.PublisherWebsiteImportLaunchRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.PublisherWebsiteImportLaunchRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getFileUid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFileName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional int64 workspace_id = 1;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteImportLaunchRequest.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteImportLaunchRequest} returns this
 */
proto.order_publisher.PublisherWebsiteImportLaunchRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string file_uid = 2;
 * @return {string}
 */
proto.order_publisher.PublisherWebsiteImportLaunchRequest.prototype.getFileUid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_publisher.PublisherWebsiteImportLaunchRequest} returns this
 */
proto.order_publisher.PublisherWebsiteImportLaunchRequest.prototype.setFileUid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string file_name = 3;
 * @return {string}
 */
proto.order_publisher.PublisherWebsiteImportLaunchRequest.prototype.getFileName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_publisher.PublisherWebsiteImportLaunchRequest} returns this
 */
proto.order_publisher.PublisherWebsiteImportLaunchRequest.prototype.setFileName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.order_publisher.PublisherWebsiteImportLatestRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.order_publisher.PublisherWebsiteImportLatestRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.order_publisher.PublisherWebsiteImportLatestRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.PublisherWebsiteImportLatestRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
workspaceId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.order_publisher.PublisherWebsiteImportLatestRequest}
 */
proto.order_publisher.PublisherWebsiteImportLatestRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.order_publisher.PublisherWebsiteImportLatestRequest;
  return proto.order_publisher.PublisherWebsiteImportLatestRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.order_publisher.PublisherWebsiteImportLatestRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.order_publisher.PublisherWebsiteImportLatestRequest}
 */
proto.order_publisher.PublisherWebsiteImportLatestRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.order_publisher.PublisherWebsiteImportLatestRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.order_publisher.PublisherWebsiteImportLatestRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.order_publisher.PublisherWebsiteImportLatestRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.PublisherWebsiteImportLatestRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 workspace_id = 1;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteImportLatestRequest.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteImportLatestRequest} returns this
 */
proto.order_publisher.PublisherWebsiteImportLatestRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.order_publisher.PublisherWebsiteImportResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.order_publisher.PublisherWebsiteImportResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.order_publisher.PublisherWebsiteImportResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.PublisherWebsiteImportResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
status: jspb.Message.getFieldWithDefault(msg, 2, 0),
fileName: jspb.Message.getFieldWithDefault(msg, 3, ""),
totalRows: jspb.Message.getFieldWithDefault(msg, 4, 0),
pendingRows: jspb.Message.getFieldWithDefault(msg, 5, 0),
createdRows: jspb.Message.getFieldWithDefault(msg, 6, 0),
skippedRows: jspb.Message.getFieldWithDefault(msg, 7, 0),
failedRows: jspb.Message.getFieldWithDefault(msg, 8, 0),
createdAt: jspb.Message.getFieldWithDefault(msg, 9, 0),
finishedAt: jspb.Message.getFieldWithDefault(msg, 10, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.order_publisher.PublisherWebsiteImportResponse}
 */
proto.order_publisher.PublisherWebsiteImportResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.order_publisher.PublisherWebsiteImportResponse;
  return proto.order_publisher.PublisherWebsiteImportResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.order_publisher.PublisherWebsiteImportResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.order_publisher.PublisherWebsiteImportResponse}
 */
proto.order_publisher.PublisherWebsiteImportResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.order_publisher.PublisherWebsiteImportStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileName(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalRows(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPendingRows(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCreatedRows(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSkippedRows(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFailedRows(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFinishedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.order_publisher.PublisherWebsiteImportResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.order_publisher.PublisherWebsiteImportResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.order_publisher.PublisherWebsiteImportResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.PublisherWebsiteImportResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getFileName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTotalRows();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getPendingRows();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getCreatedRows();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getSkippedRows();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getFailedRows();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getFinishedAt();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteImportResponse.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteImportResponse} returns this
 */
proto.order_publisher.PublisherWebsiteImportResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional PublisherWebsiteImportStatus status = 2;
 * @return {!proto.order_publisher.PublisherWebsiteImportStatus}
 */
proto.order_publisher.PublisherWebsiteImportResponse.prototype.getStatus = function() {
  return /** @type {!proto.order_publisher.PublisherWebsiteImportStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.order_publisher.PublisherWebsiteImportStatus} value
 * @return {!proto.order_publisher.PublisherWebsiteImportResponse} returns this
 */
proto.order_publisher.PublisherWebsiteImportResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string file_name = 3;
 * @return {string}
 */
proto.order_publisher.PublisherWebsiteImportResponse.prototype.getFileName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_publisher.PublisherWebsiteImportResponse} returns this
 */
proto.order_publisher.PublisherWebsiteImportResponse.prototype.setFileName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 total_rows = 4;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteImportResponse.prototype.getTotalRows = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteImportResponse} returns this
 */
proto.order_publisher.PublisherWebsiteImportResponse.prototype.setTotalRows = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 pending_rows = 5;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteImportResponse.prototype.getPendingRows = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteImportResponse} returns this
 */
proto.order_publisher.PublisherWebsiteImportResponse.prototype.setPendingRows = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 created_rows = 6;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteImportResponse.prototype.getCreatedRows = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteImportResponse} returns this
 */
proto.order_publisher.PublisherWebsiteImportResponse.prototype.setCreatedRows = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 skipped_rows = 7;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteImportResponse.prototype.getSkippedRows = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteImportResponse} returns this
 */
proto.order_publisher.PublisherWebsiteImportResponse.prototype.setSkippedRows = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 failed_rows = 8;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteImportResponse.prototype.getFailedRows = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteImportResponse} returns this
 */
proto.order_publisher.PublisherWebsiteImportResponse.prototype.setFailedRows = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int64 created_at = 9;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteImportResponse.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteImportResponse} returns this
 */
proto.order_publisher.PublisherWebsiteImportResponse.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int64 finished_at = 10;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteImportResponse.prototype.getFinishedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteImportResponse} returns this
 */
proto.order_publisher.PublisherWebsiteImportResponse.prototype.setFinishedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.order_publisher.PublisherWebsiteVerificationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.order_publisher.PublisherWebsiteVerificationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.order_publisher.PublisherWebsiteVerificationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.PublisherWebsiteVerificationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
reason: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.order_publisher.PublisherWebsiteVerificationResponse}
 */
proto.order_publisher.PublisherWebsiteVerificationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.order_publisher.PublisherWebsiteVerificationResponse;
  return proto.order_publisher.PublisherWebsiteVerificationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.order_publisher.PublisherWebsiteVerificationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.order_publisher.PublisherWebsiteVerificationResponse}
 */
proto.order_publisher.PublisherWebsiteVerificationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.order_publisher.PublisherWebsiteVerificationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.order_publisher.PublisherWebsiteVerificationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.order_publisher.PublisherWebsiteVerificationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.PublisherWebsiteVerificationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getReason();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.order_publisher.PublisherWebsiteVerificationResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.order_publisher.PublisherWebsiteVerificationResponse} returns this
 */
proto.order_publisher.PublisherWebsiteVerificationResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string reason = 2;
 * @return {string}
 */
proto.order_publisher.PublisherWebsiteVerificationResponse.prototype.getReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_publisher.PublisherWebsiteVerificationResponse} returns this
 */
proto.order_publisher.PublisherWebsiteVerificationResponse.prototype.setReason = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.order_publisher.PublisherWebsiteVerificationOption.oneofGroups_ = [[8,9]];

/**
 * @enum {number}
 */
proto.order_publisher.PublisherWebsiteVerificationOption.SettingsCase = {
  SETTINGS_NOT_SET: 0,
  VALUE: 8,
  FILE: 9
};

/**
 * @return {proto.order_publisher.PublisherWebsiteVerificationOption.SettingsCase}
 */
proto.order_publisher.PublisherWebsiteVerificationOption.prototype.getSettingsCase = function() {
  return /** @type {proto.order_publisher.PublisherWebsiteVerificationOption.SettingsCase} */(jspb.Message.computeOneofCase(this, proto.order_publisher.PublisherWebsiteVerificationOption.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.order_publisher.PublisherWebsiteVerificationOption.prototype.toObject = function(opt_includeInstance) {
  return proto.order_publisher.PublisherWebsiteVerificationOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.order_publisher.PublisherWebsiteVerificationOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.PublisherWebsiteVerificationOption.toObject = function(includeInstance, msg) {
  var f, obj = {
order: jspb.Message.getFieldWithDefault(msg, 1, 0),
type: jspb.Message.getFieldWithDefault(msg, 2, 0),
value: (f = jspb.Message.getField(msg, 8)) == null ? undefined : f,
file: (f = msg.getFile()) && common_pb.FileResponse.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.order_publisher.PublisherWebsiteVerificationOption}
 */
proto.order_publisher.PublisherWebsiteVerificationOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.order_publisher.PublisherWebsiteVerificationOption;
  return proto.order_publisher.PublisherWebsiteVerificationOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.order_publisher.PublisherWebsiteVerificationOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.order_publisher.PublisherWebsiteVerificationOption}
 */
proto.order_publisher.PublisherWebsiteVerificationOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOrder(value);
      break;
    case 2:
      var value = /** @type {!proto.common.PublisherWebsiteVerificationType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    case 9:
      var value = new common_pb.FileResponse;
      reader.readMessage(value,common_pb.FileResponse.deserializeBinaryFromReader);
      msg.setFile(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.order_publisher.PublisherWebsiteVerificationOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.order_publisher.PublisherWebsiteVerificationOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.order_publisher.PublisherWebsiteVerificationOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.PublisherWebsiteVerificationOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrder();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getFile();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      common_pb.FileResponse.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 order = 1;
 * @return {number}
 */
proto.order_publisher.PublisherWebsiteVerificationOption.prototype.getOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherWebsiteVerificationOption} returns this
 */
proto.order_publisher.PublisherWebsiteVerificationOption.prototype.setOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional common.PublisherWebsiteVerificationType type = 2;
 * @return {!proto.common.PublisherWebsiteVerificationType}
 */
proto.order_publisher.PublisherWebsiteVerificationOption.prototype.getType = function() {
  return /** @type {!proto.common.PublisherWebsiteVerificationType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.common.PublisherWebsiteVerificationType} value
 * @return {!proto.order_publisher.PublisherWebsiteVerificationOption} returns this
 */
proto.order_publisher.PublisherWebsiteVerificationOption.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string value = 8;
 * @return {string}
 */
proto.order_publisher.PublisherWebsiteVerificationOption.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_publisher.PublisherWebsiteVerificationOption} returns this
 */
proto.order_publisher.PublisherWebsiteVerificationOption.prototype.setValue = function(value) {
  return jspb.Message.setOneofField(this, 8, proto.order_publisher.PublisherWebsiteVerificationOption.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.order_publisher.PublisherWebsiteVerificationOption} returns this
 */
proto.order_publisher.PublisherWebsiteVerificationOption.prototype.clearValue = function() {
  return jspb.Message.setOneofField(this, 8, proto.order_publisher.PublisherWebsiteVerificationOption.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_publisher.PublisherWebsiteVerificationOption.prototype.hasValue = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional common.FileResponse file = 9;
 * @return {?proto.common.FileResponse}
 */
proto.order_publisher.PublisherWebsiteVerificationOption.prototype.getFile = function() {
  return /** @type{?proto.common.FileResponse} */ (
    jspb.Message.getWrapperField(this, common_pb.FileResponse, 9));
};


/**
 * @param {?proto.common.FileResponse|undefined} value
 * @return {!proto.order_publisher.PublisherWebsiteVerificationOption} returns this
*/
proto.order_publisher.PublisherWebsiteVerificationOption.prototype.setFile = function(value) {
  return jspb.Message.setOneofWrapperField(this, 9, proto.order_publisher.PublisherWebsiteVerificationOption.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_publisher.PublisherWebsiteVerificationOption} returns this
 */
proto.order_publisher.PublisherWebsiteVerificationOption.prototype.clearFile = function() {
  return this.setFile(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_publisher.PublisherWebsiteVerificationOption.prototype.hasFile = function() {
  return jspb.Message.getField(this, 9) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.order_publisher.PublisherOrderPageRequest.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.order_publisher.PublisherOrderPageRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.order_publisher.PublisherOrderPageRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.order_publisher.PublisherOrderPageRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.PublisherOrderPageRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
page: jspb.Message.getFieldWithDefault(msg, 1, 0),
limit: jspb.Message.getFieldWithDefault(msg, 2, 0),
workspaceId: jspb.Message.getFieldWithDefault(msg, 3, 0),
filtersList: jspb.Message.toObjectList(msg.getFiltersList(),
    proto.order_publisher.PublisherOrderFilter.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.order_publisher.PublisherOrderPageRequest}
 */
proto.order_publisher.PublisherOrderPageRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.order_publisher.PublisherOrderPageRequest;
  return proto.order_publisher.PublisherOrderPageRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.order_publisher.PublisherOrderPageRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.order_publisher.PublisherOrderPageRequest}
 */
proto.order_publisher.PublisherOrderPageRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    case 4:
      var value = new proto.order_publisher.PublisherOrderFilter;
      reader.readMessage(value,proto.order_publisher.PublisherOrderFilter.deserializeBinaryFromReader);
      msg.addFilters(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.order_publisher.PublisherOrderPageRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.order_publisher.PublisherOrderPageRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.order_publisher.PublisherOrderPageRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.PublisherOrderPageRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getFiltersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.order_publisher.PublisherOrderFilter.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 page = 1;
 * @return {number}
 */
proto.order_publisher.PublisherOrderPageRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherOrderPageRequest} returns this
 */
proto.order_publisher.PublisherOrderPageRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 limit = 2;
 * @return {number}
 */
proto.order_publisher.PublisherOrderPageRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherOrderPageRequest} returns this
 */
proto.order_publisher.PublisherOrderPageRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 workspace_id = 3;
 * @return {number}
 */
proto.order_publisher.PublisherOrderPageRequest.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherOrderPageRequest} returns this
 */
proto.order_publisher.PublisherOrderPageRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated PublisherOrderFilter filters = 4;
 * @return {!Array<!proto.order_publisher.PublisherOrderFilter>}
 */
proto.order_publisher.PublisherOrderPageRequest.prototype.getFiltersList = function() {
  return /** @type{!Array<!proto.order_publisher.PublisherOrderFilter>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.order_publisher.PublisherOrderFilter, 4));
};


/**
 * @param {!Array<!proto.order_publisher.PublisherOrderFilter>} value
 * @return {!proto.order_publisher.PublisherOrderPageRequest} returns this
*/
proto.order_publisher.PublisherOrderPageRequest.prototype.setFiltersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.order_publisher.PublisherOrderFilter=} opt_value
 * @param {number=} opt_index
 * @return {!proto.order_publisher.PublisherOrderFilter}
 */
proto.order_publisher.PublisherOrderPageRequest.prototype.addFilters = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.order_publisher.PublisherOrderFilter, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.order_publisher.PublisherOrderPageRequest} returns this
 */
proto.order_publisher.PublisherOrderPageRequest.prototype.clearFiltersList = function() {
  return this.setFiltersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.order_publisher.PublisherOrderFilter.prototype.toObject = function(opt_includeInstance) {
  return proto.order_publisher.PublisherOrderFilter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.order_publisher.PublisherOrderFilter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.PublisherOrderFilter.toObject = function(includeInstance, msg) {
  var f, obj = {
order: jspb.Message.getFieldWithDefault(msg, 1, 0),
field: jspb.Message.getFieldWithDefault(msg, 2, 0),
value: jspb.Message.getFieldWithDefault(msg, 3, ""),
operation: jspb.Message.getFieldWithDefault(msg, 4, 0),
join: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.order_publisher.PublisherOrderFilter}
 */
proto.order_publisher.PublisherOrderFilter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.order_publisher.PublisherOrderFilter;
  return proto.order_publisher.PublisherOrderFilter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.order_publisher.PublisherOrderFilter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.order_publisher.PublisherOrderFilter}
 */
proto.order_publisher.PublisherOrderFilter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOrder(value);
      break;
    case 2:
      var value = /** @type {!proto.order_publisher.PublisherOrderFilterField} */ (reader.readEnum());
      msg.setField(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    case 4:
      var value = /** @type {!proto.common.FilterOperation} */ (reader.readEnum());
      msg.setOperation(value);
      break;
    case 5:
      var value = /** @type {!proto.common.FilterJoinType} */ (reader.readEnum());
      msg.setJoin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.order_publisher.PublisherOrderFilter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.order_publisher.PublisherOrderFilter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.order_publisher.PublisherOrderFilter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.PublisherOrderFilter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrder();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getField();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOperation();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getJoin();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
};


/**
 * optional int32 order = 1;
 * @return {number}
 */
proto.order_publisher.PublisherOrderFilter.prototype.getOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherOrderFilter} returns this
 */
proto.order_publisher.PublisherOrderFilter.prototype.setOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional PublisherOrderFilterField field = 2;
 * @return {!proto.order_publisher.PublisherOrderFilterField}
 */
proto.order_publisher.PublisherOrderFilter.prototype.getField = function() {
  return /** @type {!proto.order_publisher.PublisherOrderFilterField} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.order_publisher.PublisherOrderFilterField} value
 * @return {!proto.order_publisher.PublisherOrderFilter} returns this
 */
proto.order_publisher.PublisherOrderFilter.prototype.setField = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string value = 3;
 * @return {string}
 */
proto.order_publisher.PublisherOrderFilter.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_publisher.PublisherOrderFilter} returns this
 */
proto.order_publisher.PublisherOrderFilter.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional common.FilterOperation operation = 4;
 * @return {!proto.common.FilterOperation}
 */
proto.order_publisher.PublisherOrderFilter.prototype.getOperation = function() {
  return /** @type {!proto.common.FilterOperation} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.common.FilterOperation} value
 * @return {!proto.order_publisher.PublisherOrderFilter} returns this
 */
proto.order_publisher.PublisherOrderFilter.prototype.setOperation = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional common.FilterJoinType join = 5;
 * @return {!proto.common.FilterJoinType}
 */
proto.order_publisher.PublisherOrderFilter.prototype.getJoin = function() {
  return /** @type {!proto.common.FilterJoinType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.common.FilterJoinType} value
 * @return {!proto.order_publisher.PublisherOrderFilter} returns this
 */
proto.order_publisher.PublisherOrderFilter.prototype.setJoin = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.order_publisher.PublisherOrderResponse.repeatedFields_ = [13];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.order_publisher.PublisherOrderResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.order_publisher.PublisherOrderResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.order_publisher.PublisherOrderResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.PublisherOrderResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
title: jspb.Message.getFieldWithDefault(msg, 2, ""),
documentUrl: jspb.Message.getFieldWithDefault(msg, 3, ""),
websiteId: jspb.Message.getFieldWithDefault(msg, 4, 0),
websiteDomain: jspb.Message.getFieldWithDefault(msg, 5, ""),
websiteName: jspb.Message.getFieldWithDefault(msg, 6, ""),
websiteLogo: jspb.Message.getFieldWithDefault(msg, 7, ""),
type: jspb.Message.getFieldWithDefault(msg, 8, 0),
status: jspb.Message.getFieldWithDefault(msg, 9, 0),
price: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
createdAt: jspb.Message.getFieldWithDefault(msg, 11, 0),
deadlineAt: jspb.Message.getFieldWithDefault(msg, 12, 0),
backlinksList: jspb.Message.toObjectList(msg.getBacklinksList(),
    proto.order_publisher.PublisherOrderBacklink.toObject, includeInstance),
totalItems: jspb.Message.getFieldWithDefault(msg, 14, 0),
requestedAt: jspb.Message.getFieldWithDefault(msg, 15, 0),
priceComment: jspb.Message.getFieldWithDefault(msg, 16, ""),
linkInsertionArticleUrl: jspb.Message.getFieldWithDefault(msg, 17, ""),
linkInsertionArticleTitle: jspb.Message.getFieldWithDefault(msg, 18, ""),
linkInsertionComment: jspb.Message.getFieldWithDefault(msg, 19, ""),
optionalChangeRequestStatus: jspb.Message.getFieldWithDefault(msg, 20, 0),
optionalChangeRequestId: jspb.Message.getFieldWithDefault(msg, 21, 0),
number: jspb.Message.getFieldWithDefault(msg, 22, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.order_publisher.PublisherOrderResponse}
 */
proto.order_publisher.PublisherOrderResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.order_publisher.PublisherOrderResponse;
  return proto.order_publisher.PublisherOrderResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.order_publisher.PublisherOrderResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.order_publisher.PublisherOrderResponse}
 */
proto.order_publisher.PublisherOrderResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocumentUrl(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWebsiteId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setWebsiteDomain(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setWebsiteName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setWebsiteLogo(value);
      break;
    case 8:
      var value = /** @type {!proto.common.PublisherOrderType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 9:
      var value = /** @type {!proto.common.PublisherOrderStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPrice(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDeadlineAt(value);
      break;
    case 13:
      var value = new proto.order_publisher.PublisherOrderBacklink;
      reader.readMessage(value,proto.order_publisher.PublisherOrderBacklink.deserializeBinaryFromReader);
      msg.addBacklinks(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalItems(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRequestedAt(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setPriceComment(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setLinkInsertionArticleUrl(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setLinkInsertionArticleTitle(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setLinkInsertionComment(value);
      break;
    case 20:
      var value = /** @type {!proto.order_publisher.ChangeRequestStatus} */ (reader.readEnum());
      msg.setOptionalChangeRequestStatus(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOptionalChangeRequestId(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.order_publisher.PublisherOrderResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.order_publisher.PublisherOrderResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.order_publisher.PublisherOrderResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.PublisherOrderResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDocumentUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getWebsiteId();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getWebsiteDomain();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getWebsiteName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getWebsiteLogo();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      10,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getDeadlineAt();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getBacklinksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      13,
      f,
      proto.order_publisher.PublisherOrderBacklink.serializeBinaryToWriter
    );
  }
  f = message.getTotalItems();
  if (f !== 0) {
    writer.writeInt32(
      14,
      f
    );
  }
  f = message.getRequestedAt();
  if (f !== 0) {
    writer.writeInt64(
      15,
      f
    );
  }
  f = message.getPriceComment();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getLinkInsertionArticleUrl();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getLinkInsertionArticleTitle();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getLinkInsertionComment();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getOptionalChangeRequestStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      20,
      f
    );
  }
  f = message.getOptionalChangeRequestId();
  if (f !== 0) {
    writer.writeInt64(
      21,
      f
    );
  }
  f = message.getNumber();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.order_publisher.PublisherOrderResponse.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherOrderResponse} returns this
 */
proto.order_publisher.PublisherOrderResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.order_publisher.PublisherOrderResponse.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_publisher.PublisherOrderResponse} returns this
 */
proto.order_publisher.PublisherOrderResponse.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string document_url = 3;
 * @return {string}
 */
proto.order_publisher.PublisherOrderResponse.prototype.getDocumentUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_publisher.PublisherOrderResponse} returns this
 */
proto.order_publisher.PublisherOrderResponse.prototype.setDocumentUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 website_id = 4;
 * @return {number}
 */
proto.order_publisher.PublisherOrderResponse.prototype.getWebsiteId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherOrderResponse} returns this
 */
proto.order_publisher.PublisherOrderResponse.prototype.setWebsiteId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string website_domain = 5;
 * @return {string}
 */
proto.order_publisher.PublisherOrderResponse.prototype.getWebsiteDomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_publisher.PublisherOrderResponse} returns this
 */
proto.order_publisher.PublisherOrderResponse.prototype.setWebsiteDomain = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string website_name = 6;
 * @return {string}
 */
proto.order_publisher.PublisherOrderResponse.prototype.getWebsiteName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_publisher.PublisherOrderResponse} returns this
 */
proto.order_publisher.PublisherOrderResponse.prototype.setWebsiteName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string website_logo = 7;
 * @return {string}
 */
proto.order_publisher.PublisherOrderResponse.prototype.getWebsiteLogo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_publisher.PublisherOrderResponse} returns this
 */
proto.order_publisher.PublisherOrderResponse.prototype.setWebsiteLogo = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional common.PublisherOrderType type = 8;
 * @return {!proto.common.PublisherOrderType}
 */
proto.order_publisher.PublisherOrderResponse.prototype.getType = function() {
  return /** @type {!proto.common.PublisherOrderType} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.common.PublisherOrderType} value
 * @return {!proto.order_publisher.PublisherOrderResponse} returns this
 */
proto.order_publisher.PublisherOrderResponse.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional common.PublisherOrderStatus status = 9;
 * @return {!proto.common.PublisherOrderStatus}
 */
proto.order_publisher.PublisherOrderResponse.prototype.getStatus = function() {
  return /** @type {!proto.common.PublisherOrderStatus} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.common.PublisherOrderStatus} value
 * @return {!proto.order_publisher.PublisherOrderResponse} returns this
 */
proto.order_publisher.PublisherOrderResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional double price = 10;
 * @return {number}
 */
proto.order_publisher.PublisherOrderResponse.prototype.getPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherOrderResponse} returns this
 */
proto.order_publisher.PublisherOrderResponse.prototype.setPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};


/**
 * optional int64 created_at = 11;
 * @return {number}
 */
proto.order_publisher.PublisherOrderResponse.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherOrderResponse} returns this
 */
proto.order_publisher.PublisherOrderResponse.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int64 deadline_at = 12;
 * @return {number}
 */
proto.order_publisher.PublisherOrderResponse.prototype.getDeadlineAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherOrderResponse} returns this
 */
proto.order_publisher.PublisherOrderResponse.prototype.setDeadlineAt = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * repeated PublisherOrderBacklink backlinks = 13;
 * @return {!Array<!proto.order_publisher.PublisherOrderBacklink>}
 */
proto.order_publisher.PublisherOrderResponse.prototype.getBacklinksList = function() {
  return /** @type{!Array<!proto.order_publisher.PublisherOrderBacklink>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.order_publisher.PublisherOrderBacklink, 13));
};


/**
 * @param {!Array<!proto.order_publisher.PublisherOrderBacklink>} value
 * @return {!proto.order_publisher.PublisherOrderResponse} returns this
*/
proto.order_publisher.PublisherOrderResponse.prototype.setBacklinksList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 13, value);
};


/**
 * @param {!proto.order_publisher.PublisherOrderBacklink=} opt_value
 * @param {number=} opt_index
 * @return {!proto.order_publisher.PublisherOrderBacklink}
 */
proto.order_publisher.PublisherOrderResponse.prototype.addBacklinks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 13, opt_value, proto.order_publisher.PublisherOrderBacklink, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.order_publisher.PublisherOrderResponse} returns this
 */
proto.order_publisher.PublisherOrderResponse.prototype.clearBacklinksList = function() {
  return this.setBacklinksList([]);
};


/**
 * optional int32 total_items = 14;
 * @return {number}
 */
proto.order_publisher.PublisherOrderResponse.prototype.getTotalItems = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherOrderResponse} returns this
 */
proto.order_publisher.PublisherOrderResponse.prototype.setTotalItems = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int64 requested_at = 15;
 * @return {number}
 */
proto.order_publisher.PublisherOrderResponse.prototype.getRequestedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherOrderResponse} returns this
 */
proto.order_publisher.PublisherOrderResponse.prototype.setRequestedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional string price_comment = 16;
 * @return {string}
 */
proto.order_publisher.PublisherOrderResponse.prototype.getPriceComment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_publisher.PublisherOrderResponse} returns this
 */
proto.order_publisher.PublisherOrderResponse.prototype.setPriceComment = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string link_insertion_article_url = 17;
 * @return {string}
 */
proto.order_publisher.PublisherOrderResponse.prototype.getLinkInsertionArticleUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_publisher.PublisherOrderResponse} returns this
 */
proto.order_publisher.PublisherOrderResponse.prototype.setLinkInsertionArticleUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string link_insertion_article_title = 18;
 * @return {string}
 */
proto.order_publisher.PublisherOrderResponse.prototype.getLinkInsertionArticleTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_publisher.PublisherOrderResponse} returns this
 */
proto.order_publisher.PublisherOrderResponse.prototype.setLinkInsertionArticleTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string link_insertion_comment = 19;
 * @return {string}
 */
proto.order_publisher.PublisherOrderResponse.prototype.getLinkInsertionComment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_publisher.PublisherOrderResponse} returns this
 */
proto.order_publisher.PublisherOrderResponse.prototype.setLinkInsertionComment = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional ChangeRequestStatus optional_change_request_status = 20;
 * @return {!proto.order_publisher.ChangeRequestStatus}
 */
proto.order_publisher.PublisherOrderResponse.prototype.getOptionalChangeRequestStatus = function() {
  return /** @type {!proto.order_publisher.ChangeRequestStatus} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {!proto.order_publisher.ChangeRequestStatus} value
 * @return {!proto.order_publisher.PublisherOrderResponse} returns this
 */
proto.order_publisher.PublisherOrderResponse.prototype.setOptionalChangeRequestStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 20, value);
};


/**
 * optional int64 optional_change_request_id = 21;
 * @return {number}
 */
proto.order_publisher.PublisherOrderResponse.prototype.getOptionalChangeRequestId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherOrderResponse} returns this
 */
proto.order_publisher.PublisherOrderResponse.prototype.setOptionalChangeRequestId = function(value) {
  return jspb.Message.setProto3IntField(this, 21, value);
};


/**
 * optional string number = 22;
 * @return {string}
 */
proto.order_publisher.PublisherOrderResponse.prototype.getNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_publisher.PublisherOrderResponse} returns this
 */
proto.order_publisher.PublisherOrderResponse.prototype.setNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.order_publisher.PublisherOrderBacklink.prototype.toObject = function(opt_includeInstance) {
  return proto.order_publisher.PublisherOrderBacklink.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.order_publisher.PublisherOrderBacklink} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.PublisherOrderBacklink.toObject = function(includeInstance, msg) {
  var f, obj = {
url: jspb.Message.getFieldWithDefault(msg, 1, ""),
anchor: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.order_publisher.PublisherOrderBacklink}
 */
proto.order_publisher.PublisherOrderBacklink.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.order_publisher.PublisherOrderBacklink;
  return proto.order_publisher.PublisherOrderBacklink.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.order_publisher.PublisherOrderBacklink} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.order_publisher.PublisherOrderBacklink}
 */
proto.order_publisher.PublisherOrderBacklink.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAnchor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.order_publisher.PublisherOrderBacklink.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.order_publisher.PublisherOrderBacklink.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.order_publisher.PublisherOrderBacklink} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.PublisherOrderBacklink.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAnchor();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string url = 1;
 * @return {string}
 */
proto.order_publisher.PublisherOrderBacklink.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_publisher.PublisherOrderBacklink} returns this
 */
proto.order_publisher.PublisherOrderBacklink.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string anchor = 2;
 * @return {string}
 */
proto.order_publisher.PublisherOrderBacklink.prototype.getAnchor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_publisher.PublisherOrderBacklink} returns this
 */
proto.order_publisher.PublisherOrderBacklink.prototype.setAnchor = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.order_publisher.PublisherOrderStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.order_publisher.PublisherOrderStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.order_publisher.PublisherOrderStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.PublisherOrderStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
workspaceId: jspb.Message.getFieldWithDefault(msg, 2, 0),
status: jspb.Message.getFieldWithDefault(msg, 3, 0),
publishedUrl: jspb.Message.getFieldWithDefault(msg, 4, ""),
optFeedback: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.order_publisher.PublisherOrderStatusRequest}
 */
proto.order_publisher.PublisherOrderStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.order_publisher.PublisherOrderStatusRequest;
  return proto.order_publisher.PublisherOrderStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.order_publisher.PublisherOrderStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.order_publisher.PublisherOrderStatusRequest}
 */
proto.order_publisher.PublisherOrderStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    case 3:
      var value = /** @type {!proto.common.PublisherOrderStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPublishedUrl(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setOptFeedback(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.order_publisher.PublisherOrderStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.order_publisher.PublisherOrderStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.order_publisher.PublisherOrderStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.PublisherOrderStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getPublishedUrl();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getOptFeedback();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.order_publisher.PublisherOrderStatusRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherOrderStatusRequest} returns this
 */
proto.order_publisher.PublisherOrderStatusRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 workspace_id = 2;
 * @return {number}
 */
proto.order_publisher.PublisherOrderStatusRequest.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherOrderStatusRequest} returns this
 */
proto.order_publisher.PublisherOrderStatusRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional common.PublisherOrderStatus status = 3;
 * @return {!proto.common.PublisherOrderStatus}
 */
proto.order_publisher.PublisherOrderStatusRequest.prototype.getStatus = function() {
  return /** @type {!proto.common.PublisherOrderStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.common.PublisherOrderStatus} value
 * @return {!proto.order_publisher.PublisherOrderStatusRequest} returns this
 */
proto.order_publisher.PublisherOrderStatusRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string published_url = 4;
 * @return {string}
 */
proto.order_publisher.PublisherOrderStatusRequest.prototype.getPublishedUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_publisher.PublisherOrderStatusRequest} returns this
 */
proto.order_publisher.PublisherOrderStatusRequest.prototype.setPublishedUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string opt_feedback = 5;
 * @return {string}
 */
proto.order_publisher.PublisherOrderStatusRequest.prototype.getOptFeedback = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_publisher.PublisherOrderStatusRequest} returns this
 */
proto.order_publisher.PublisherOrderStatusRequest.prototype.setOptFeedback = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.order_publisher.PublisherOrderPublishedUrlRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.order_publisher.PublisherOrderPublishedUrlRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.order_publisher.PublisherOrderPublishedUrlRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.PublisherOrderPublishedUrlRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
orderId: jspb.Message.getFieldWithDefault(msg, 1, 0),
workspaceId: jspb.Message.getFieldWithDefault(msg, 2, 0),
publishedUrl: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.order_publisher.PublisherOrderPublishedUrlRequest}
 */
proto.order_publisher.PublisherOrderPublishedUrlRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.order_publisher.PublisherOrderPublishedUrlRequest;
  return proto.order_publisher.PublisherOrderPublishedUrlRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.order_publisher.PublisherOrderPublishedUrlRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.order_publisher.PublisherOrderPublishedUrlRequest}
 */
proto.order_publisher.PublisherOrderPublishedUrlRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOrderId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPublishedUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.order_publisher.PublisherOrderPublishedUrlRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.order_publisher.PublisherOrderPublishedUrlRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.order_publisher.PublisherOrderPublishedUrlRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.PublisherOrderPublishedUrlRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getPublishedUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional int64 order_id = 1;
 * @return {number}
 */
proto.order_publisher.PublisherOrderPublishedUrlRequest.prototype.getOrderId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherOrderPublishedUrlRequest} returns this
 */
proto.order_publisher.PublisherOrderPublishedUrlRequest.prototype.setOrderId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 workspace_id = 2;
 * @return {number}
 */
proto.order_publisher.PublisherOrderPublishedUrlRequest.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.PublisherOrderPublishedUrlRequest} returns this
 */
proto.order_publisher.PublisherOrderPublishedUrlRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string published_url = 3;
 * @return {string}
 */
proto.order_publisher.PublisherOrderPublishedUrlRequest.prototype.getPublishedUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_publisher.PublisherOrderPublishedUrlRequest} returns this
 */
proto.order_publisher.PublisherOrderPublishedUrlRequest.prototype.setPublishedUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.order_publisher.ChangeRequestAttachedFile.prototype.toObject = function(opt_includeInstance) {
  return proto.order_publisher.ChangeRequestAttachedFile.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.order_publisher.ChangeRequestAttachedFile} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.ChangeRequestAttachedFile.toObject = function(includeInstance, msg) {
  var f, obj = {
uid: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
type: jspb.Message.getFieldWithDefault(msg, 3, ""),
size: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.order_publisher.ChangeRequestAttachedFile}
 */
proto.order_publisher.ChangeRequestAttachedFile.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.order_publisher.ChangeRequestAttachedFile;
  return proto.order_publisher.ChangeRequestAttachedFile.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.order_publisher.ChangeRequestAttachedFile} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.order_publisher.ChangeRequestAttachedFile}
 */
proto.order_publisher.ChangeRequestAttachedFile.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.order_publisher.ChangeRequestAttachedFile.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.order_publisher.ChangeRequestAttachedFile.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.order_publisher.ChangeRequestAttachedFile} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.ChangeRequestAttachedFile.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSize();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional string uid = 1;
 * @return {string}
 */
proto.order_publisher.ChangeRequestAttachedFile.prototype.getUid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_publisher.ChangeRequestAttachedFile} returns this
 */
proto.order_publisher.ChangeRequestAttachedFile.prototype.setUid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.order_publisher.ChangeRequestAttachedFile.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_publisher.ChangeRequestAttachedFile} returns this
 */
proto.order_publisher.ChangeRequestAttachedFile.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string type = 3;
 * @return {string}
 */
proto.order_publisher.ChangeRequestAttachedFile.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_publisher.ChangeRequestAttachedFile} returns this
 */
proto.order_publisher.ChangeRequestAttachedFile.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 size = 4;
 * @return {number}
 */
proto.order_publisher.ChangeRequestAttachedFile.prototype.getSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.ChangeRequestAttachedFile} returns this
 */
proto.order_publisher.ChangeRequestAttachedFile.prototype.setSize = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.order_publisher.ChangeRequestMessageResponse.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.order_publisher.ChangeRequestMessageResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.order_publisher.ChangeRequestMessageResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.order_publisher.ChangeRequestMessageResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.ChangeRequestMessageResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
authorType: jspb.Message.getFieldWithDefault(msg, 2, 0),
optionalAuthorId: jspb.Message.getFieldWithDefault(msg, 3, 0),
authorName: jspb.Message.getFieldWithDefault(msg, 4, ""),
body: jspb.Message.getFieldWithDefault(msg, 5, ""),
createdAt: jspb.Message.getFieldWithDefault(msg, 6, 0),
attachedFilesList: jspb.Message.toObjectList(msg.getAttachedFilesList(),
    proto.order_publisher.ChangeRequestAttachedFile.toObject, includeInstance),
optionalReplyToMessageId: jspb.Message.getFieldWithDefault(msg, 8, 0),
internalNote: jspb.Message.getBooleanFieldWithDefault(msg, 9, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.order_publisher.ChangeRequestMessageResponse}
 */
proto.order_publisher.ChangeRequestMessageResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.order_publisher.ChangeRequestMessageResponse;
  return proto.order_publisher.ChangeRequestMessageResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.order_publisher.ChangeRequestMessageResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.order_publisher.ChangeRequestMessageResponse}
 */
proto.order_publisher.ChangeRequestMessageResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.order_publisher.ChangeRequestAuthorType} */ (reader.readEnum());
      msg.setAuthorType(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOptionalAuthorId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuthorName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setBody(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 7:
      var value = new proto.order_publisher.ChangeRequestAttachedFile;
      reader.readMessage(value,proto.order_publisher.ChangeRequestAttachedFile.deserializeBinaryFromReader);
      msg.addAttachedFiles(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOptionalReplyToMessageId(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setInternalNote(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.order_publisher.ChangeRequestMessageResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.order_publisher.ChangeRequestMessageResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.order_publisher.ChangeRequestMessageResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.ChangeRequestMessageResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getAuthorType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getOptionalAuthorId();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getAuthorName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getBody();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getAttachedFilesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.order_publisher.ChangeRequestAttachedFile.serializeBinaryToWriter
    );
  }
  f = message.getOptionalReplyToMessageId();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getInternalNote();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.order_publisher.ChangeRequestMessageResponse.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.ChangeRequestMessageResponse} returns this
 */
proto.order_publisher.ChangeRequestMessageResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional ChangeRequestAuthorType author_type = 2;
 * @return {!proto.order_publisher.ChangeRequestAuthorType}
 */
proto.order_publisher.ChangeRequestMessageResponse.prototype.getAuthorType = function() {
  return /** @type {!proto.order_publisher.ChangeRequestAuthorType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.order_publisher.ChangeRequestAuthorType} value
 * @return {!proto.order_publisher.ChangeRequestMessageResponse} returns this
 */
proto.order_publisher.ChangeRequestMessageResponse.prototype.setAuthorType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional int64 optional_author_id = 3;
 * @return {number}
 */
proto.order_publisher.ChangeRequestMessageResponse.prototype.getOptionalAuthorId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.ChangeRequestMessageResponse} returns this
 */
proto.order_publisher.ChangeRequestMessageResponse.prototype.setOptionalAuthorId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string author_name = 4;
 * @return {string}
 */
proto.order_publisher.ChangeRequestMessageResponse.prototype.getAuthorName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_publisher.ChangeRequestMessageResponse} returns this
 */
proto.order_publisher.ChangeRequestMessageResponse.prototype.setAuthorName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string body = 5;
 * @return {string}
 */
proto.order_publisher.ChangeRequestMessageResponse.prototype.getBody = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_publisher.ChangeRequestMessageResponse} returns this
 */
proto.order_publisher.ChangeRequestMessageResponse.prototype.setBody = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 created_at = 6;
 * @return {number}
 */
proto.order_publisher.ChangeRequestMessageResponse.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.ChangeRequestMessageResponse} returns this
 */
proto.order_publisher.ChangeRequestMessageResponse.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * repeated ChangeRequestAttachedFile attached_files = 7;
 * @return {!Array<!proto.order_publisher.ChangeRequestAttachedFile>}
 */
proto.order_publisher.ChangeRequestMessageResponse.prototype.getAttachedFilesList = function() {
  return /** @type{!Array<!proto.order_publisher.ChangeRequestAttachedFile>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.order_publisher.ChangeRequestAttachedFile, 7));
};


/**
 * @param {!Array<!proto.order_publisher.ChangeRequestAttachedFile>} value
 * @return {!proto.order_publisher.ChangeRequestMessageResponse} returns this
*/
proto.order_publisher.ChangeRequestMessageResponse.prototype.setAttachedFilesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.order_publisher.ChangeRequestAttachedFile=} opt_value
 * @param {number=} opt_index
 * @return {!proto.order_publisher.ChangeRequestAttachedFile}
 */
proto.order_publisher.ChangeRequestMessageResponse.prototype.addAttachedFiles = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.order_publisher.ChangeRequestAttachedFile, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.order_publisher.ChangeRequestMessageResponse} returns this
 */
proto.order_publisher.ChangeRequestMessageResponse.prototype.clearAttachedFilesList = function() {
  return this.setAttachedFilesList([]);
};


/**
 * optional int64 optional_reply_to_message_id = 8;
 * @return {number}
 */
proto.order_publisher.ChangeRequestMessageResponse.prototype.getOptionalReplyToMessageId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.ChangeRequestMessageResponse} returns this
 */
proto.order_publisher.ChangeRequestMessageResponse.prototype.setOptionalReplyToMessageId = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional bool internal_note = 9;
 * @return {boolean}
 */
proto.order_publisher.ChangeRequestMessageResponse.prototype.getInternalNote = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.order_publisher.ChangeRequestMessageResponse} returns this
 */
proto.order_publisher.ChangeRequestMessageResponse.prototype.setInternalNote = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.order_publisher.ChangeRequestResponse.repeatedFields_ = [5,6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.order_publisher.ChangeRequestResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.order_publisher.ChangeRequestResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.order_publisher.ChangeRequestResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.ChangeRequestResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
publisherOrderId: jspb.Message.getFieldWithDefault(msg, 2, 0),
workspaceId: jspb.Message.getFieldWithDefault(msg, 3, 0),
status: jspb.Message.getFieldWithDefault(msg, 4, 0),
areasList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
messagesList: jspb.Message.toObjectList(msg.getMessagesList(),
    proto.order_publisher.ChangeRequestMessageResponse.toObject, includeInstance),
createdAt: jspb.Message.getFieldWithDefault(msg, 7, 0),
updatedAt: jspb.Message.getFieldWithDefault(msg, 8, 0),
orderNumber: jspb.Message.getFieldWithDefault(msg, 9, ""),
articleUrl: jspb.Message.getFieldWithDefault(msg, 10, ""),
targetUrl: jspb.Message.getFieldWithDefault(msg, 11, ""),
anchor: jspb.Message.getFieldWithDefault(msg, 12, ""),
resolvedAt: jspb.Message.getFieldWithDefault(msg, 13, 0),
inWorkDurationMs: jspb.Message.getFieldWithDefault(msg, 14, 0),
unreadCount: jspb.Message.getFieldWithDefault(msg, 15, 0),
publisherLastSeenAt: jspb.Message.getFieldWithDefault(msg, 16, 0),
submittedLiveUrl: jspb.Message.getFieldWithDefault(msg, 17, ""),
submittedLiveUrlAt: jspb.Message.getFieldWithDefault(msg, 18, 0),
submittedLiveUrlStatus: jspb.Message.getFieldWithDefault(msg, 19, 0),
submittedLiveUrlReviewedAt: jspb.Message.getFieldWithDefault(msg, 20, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.order_publisher.ChangeRequestResponse}
 */
proto.order_publisher.ChangeRequestResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.order_publisher.ChangeRequestResponse;
  return proto.order_publisher.ChangeRequestResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.order_publisher.ChangeRequestResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.order_publisher.ChangeRequestResponse}
 */
proto.order_publisher.ChangeRequestResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPublisherOrderId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    case 4:
      var value = /** @type {!proto.order_publisher.ChangeRequestStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 5:
      var values = /** @type {!Array<!proto.order_publisher.ChangeRequestArea>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addAreas(values[i]);
      }
      break;
    case 6:
      var value = new proto.order_publisher.ChangeRequestMessageResponse;
      reader.readMessage(value,proto.order_publisher.ChangeRequestMessageResponse.deserializeBinaryFromReader);
      msg.addMessages(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAt(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderNumber(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setArticleUrl(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetUrl(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setAnchor(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setResolvedAt(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setInWorkDurationMs(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUnreadCount(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPublisherLastSeenAt(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubmittedLiveUrl(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSubmittedLiveUrlAt(value);
      break;
    case 19:
      var value = /** @type {!proto.order_publisher.SubmittedLiveUrlStatus} */ (reader.readEnum());
      msg.setSubmittedLiveUrlStatus(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSubmittedLiveUrlReviewedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.order_publisher.ChangeRequestResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.order_publisher.ChangeRequestResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.order_publisher.ChangeRequestResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.ChangeRequestResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getPublisherOrderId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getAreasList();
  if (f.length > 0) {
    writer.writePackedEnum(
      5,
      f
    );
  }
  f = message.getMessagesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.order_publisher.ChangeRequestMessageResponse.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getOrderNumber();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getArticleUrl();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getTargetUrl();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getAnchor();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getResolvedAt();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
  f = message.getInWorkDurationMs();
  if (f !== 0) {
    writer.writeInt64(
      14,
      f
    );
  }
  f = message.getUnreadCount();
  if (f !== 0) {
    writer.writeInt32(
      15,
      f
    );
  }
  f = message.getPublisherLastSeenAt();
  if (f !== 0) {
    writer.writeInt64(
      16,
      f
    );
  }
  f = message.getSubmittedLiveUrl();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getSubmittedLiveUrlAt();
  if (f !== 0) {
    writer.writeInt64(
      18,
      f
    );
  }
  f = message.getSubmittedLiveUrlStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      19,
      f
    );
  }
  f = message.getSubmittedLiveUrlReviewedAt();
  if (f !== 0) {
    writer.writeInt64(
      20,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.order_publisher.ChangeRequestResponse.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.ChangeRequestResponse} returns this
 */
proto.order_publisher.ChangeRequestResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 publisher_order_id = 2;
 * @return {number}
 */
proto.order_publisher.ChangeRequestResponse.prototype.getPublisherOrderId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.ChangeRequestResponse} returns this
 */
proto.order_publisher.ChangeRequestResponse.prototype.setPublisherOrderId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 workspace_id = 3;
 * @return {number}
 */
proto.order_publisher.ChangeRequestResponse.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.ChangeRequestResponse} returns this
 */
proto.order_publisher.ChangeRequestResponse.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional ChangeRequestStatus status = 4;
 * @return {!proto.order_publisher.ChangeRequestStatus}
 */
proto.order_publisher.ChangeRequestResponse.prototype.getStatus = function() {
  return /** @type {!proto.order_publisher.ChangeRequestStatus} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.order_publisher.ChangeRequestStatus} value
 * @return {!proto.order_publisher.ChangeRequestResponse} returns this
 */
proto.order_publisher.ChangeRequestResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * repeated ChangeRequestArea areas = 5;
 * @return {!Array<!proto.order_publisher.ChangeRequestArea>}
 */
proto.order_publisher.ChangeRequestResponse.prototype.getAreasList = function() {
  return /** @type {!Array<!proto.order_publisher.ChangeRequestArea>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<!proto.order_publisher.ChangeRequestArea>} value
 * @return {!proto.order_publisher.ChangeRequestResponse} returns this
 */
proto.order_publisher.ChangeRequestResponse.prototype.setAreasList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {!proto.order_publisher.ChangeRequestArea} value
 * @param {number=} opt_index
 * @return {!proto.order_publisher.ChangeRequestResponse} returns this
 */
proto.order_publisher.ChangeRequestResponse.prototype.addAreas = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.order_publisher.ChangeRequestResponse} returns this
 */
proto.order_publisher.ChangeRequestResponse.prototype.clearAreasList = function() {
  return this.setAreasList([]);
};


/**
 * repeated ChangeRequestMessageResponse messages = 6;
 * @return {!Array<!proto.order_publisher.ChangeRequestMessageResponse>}
 */
proto.order_publisher.ChangeRequestResponse.prototype.getMessagesList = function() {
  return /** @type{!Array<!proto.order_publisher.ChangeRequestMessageResponse>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.order_publisher.ChangeRequestMessageResponse, 6));
};


/**
 * @param {!Array<!proto.order_publisher.ChangeRequestMessageResponse>} value
 * @return {!proto.order_publisher.ChangeRequestResponse} returns this
*/
proto.order_publisher.ChangeRequestResponse.prototype.setMessagesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.order_publisher.ChangeRequestMessageResponse=} opt_value
 * @param {number=} opt_index
 * @return {!proto.order_publisher.ChangeRequestMessageResponse}
 */
proto.order_publisher.ChangeRequestResponse.prototype.addMessages = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.order_publisher.ChangeRequestMessageResponse, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.order_publisher.ChangeRequestResponse} returns this
 */
proto.order_publisher.ChangeRequestResponse.prototype.clearMessagesList = function() {
  return this.setMessagesList([]);
};


/**
 * optional int64 created_at = 7;
 * @return {number}
 */
proto.order_publisher.ChangeRequestResponse.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.ChangeRequestResponse} returns this
 */
proto.order_publisher.ChangeRequestResponse.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 updated_at = 8;
 * @return {number}
 */
proto.order_publisher.ChangeRequestResponse.prototype.getUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.ChangeRequestResponse} returns this
 */
proto.order_publisher.ChangeRequestResponse.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string order_number = 9;
 * @return {string}
 */
proto.order_publisher.ChangeRequestResponse.prototype.getOrderNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_publisher.ChangeRequestResponse} returns this
 */
proto.order_publisher.ChangeRequestResponse.prototype.setOrderNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string article_url = 10;
 * @return {string}
 */
proto.order_publisher.ChangeRequestResponse.prototype.getArticleUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_publisher.ChangeRequestResponse} returns this
 */
proto.order_publisher.ChangeRequestResponse.prototype.setArticleUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string target_url = 11;
 * @return {string}
 */
proto.order_publisher.ChangeRequestResponse.prototype.getTargetUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_publisher.ChangeRequestResponse} returns this
 */
proto.order_publisher.ChangeRequestResponse.prototype.setTargetUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string anchor = 12;
 * @return {string}
 */
proto.order_publisher.ChangeRequestResponse.prototype.getAnchor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_publisher.ChangeRequestResponse} returns this
 */
proto.order_publisher.ChangeRequestResponse.prototype.setAnchor = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional int64 resolved_at = 13;
 * @return {number}
 */
proto.order_publisher.ChangeRequestResponse.prototype.getResolvedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.ChangeRequestResponse} returns this
 */
proto.order_publisher.ChangeRequestResponse.prototype.setResolvedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional int64 in_work_duration_ms = 14;
 * @return {number}
 */
proto.order_publisher.ChangeRequestResponse.prototype.getInWorkDurationMs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.ChangeRequestResponse} returns this
 */
proto.order_publisher.ChangeRequestResponse.prototype.setInWorkDurationMs = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int32 unread_count = 15;
 * @return {number}
 */
proto.order_publisher.ChangeRequestResponse.prototype.getUnreadCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.ChangeRequestResponse} returns this
 */
proto.order_publisher.ChangeRequestResponse.prototype.setUnreadCount = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional int64 publisher_last_seen_at = 16;
 * @return {number}
 */
proto.order_publisher.ChangeRequestResponse.prototype.getPublisherLastSeenAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.ChangeRequestResponse} returns this
 */
proto.order_publisher.ChangeRequestResponse.prototype.setPublisherLastSeenAt = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional string submitted_live_url = 17;
 * @return {string}
 */
proto.order_publisher.ChangeRequestResponse.prototype.getSubmittedLiveUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_publisher.ChangeRequestResponse} returns this
 */
proto.order_publisher.ChangeRequestResponse.prototype.setSubmittedLiveUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional int64 submitted_live_url_at = 18;
 * @return {number}
 */
proto.order_publisher.ChangeRequestResponse.prototype.getSubmittedLiveUrlAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.ChangeRequestResponse} returns this
 */
proto.order_publisher.ChangeRequestResponse.prototype.setSubmittedLiveUrlAt = function(value) {
  return jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional SubmittedLiveUrlStatus submitted_live_url_status = 19;
 * @return {!proto.order_publisher.SubmittedLiveUrlStatus}
 */
proto.order_publisher.ChangeRequestResponse.prototype.getSubmittedLiveUrlStatus = function() {
  return /** @type {!proto.order_publisher.SubmittedLiveUrlStatus} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {!proto.order_publisher.SubmittedLiveUrlStatus} value
 * @return {!proto.order_publisher.ChangeRequestResponse} returns this
 */
proto.order_publisher.ChangeRequestResponse.prototype.setSubmittedLiveUrlStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 19, value);
};


/**
 * optional int64 submitted_live_url_reviewed_at = 20;
 * @return {number}
 */
proto.order_publisher.ChangeRequestResponse.prototype.getSubmittedLiveUrlReviewedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.ChangeRequestResponse} returns this
 */
proto.order_publisher.ChangeRequestResponse.prototype.setSubmittedLiveUrlReviewedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 20, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.order_publisher.GetChangeRequestRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.order_publisher.GetChangeRequestRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.order_publisher.GetChangeRequestRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.GetChangeRequestRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
publisherOrderId: jspb.Message.getFieldWithDefault(msg, 1, 0),
workspaceId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.order_publisher.GetChangeRequestRequest}
 */
proto.order_publisher.GetChangeRequestRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.order_publisher.GetChangeRequestRequest;
  return proto.order_publisher.GetChangeRequestRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.order_publisher.GetChangeRequestRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.order_publisher.GetChangeRequestRequest}
 */
proto.order_publisher.GetChangeRequestRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPublisherOrderId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.order_publisher.GetChangeRequestRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.order_publisher.GetChangeRequestRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.order_publisher.GetChangeRequestRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.GetChangeRequestRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPublisherOrderId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional int64 publisher_order_id = 1;
 * @return {number}
 */
proto.order_publisher.GetChangeRequestRequest.prototype.getPublisherOrderId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.GetChangeRequestRequest} returns this
 */
proto.order_publisher.GetChangeRequestRequest.prototype.setPublisherOrderId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 workspace_id = 2;
 * @return {number}
 */
proto.order_publisher.GetChangeRequestRequest.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.GetChangeRequestRequest} returns this
 */
proto.order_publisher.GetChangeRequestRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.order_publisher.MarkChangeRequestSeenRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.order_publisher.MarkChangeRequestSeenRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.order_publisher.MarkChangeRequestSeenRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.MarkChangeRequestSeenRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
changeRequestId: jspb.Message.getFieldWithDefault(msg, 1, 0),
workspaceId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.order_publisher.MarkChangeRequestSeenRequest}
 */
proto.order_publisher.MarkChangeRequestSeenRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.order_publisher.MarkChangeRequestSeenRequest;
  return proto.order_publisher.MarkChangeRequestSeenRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.order_publisher.MarkChangeRequestSeenRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.order_publisher.MarkChangeRequestSeenRequest}
 */
proto.order_publisher.MarkChangeRequestSeenRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setChangeRequestId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.order_publisher.MarkChangeRequestSeenRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.order_publisher.MarkChangeRequestSeenRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.order_publisher.MarkChangeRequestSeenRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.MarkChangeRequestSeenRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChangeRequestId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional int64 change_request_id = 1;
 * @return {number}
 */
proto.order_publisher.MarkChangeRequestSeenRequest.prototype.getChangeRequestId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.MarkChangeRequestSeenRequest} returns this
 */
proto.order_publisher.MarkChangeRequestSeenRequest.prototype.setChangeRequestId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 workspace_id = 2;
 * @return {number}
 */
proto.order_publisher.MarkChangeRequestSeenRequest.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.MarkChangeRequestSeenRequest} returns this
 */
proto.order_publisher.MarkChangeRequestSeenRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.order_publisher.SubmitChangesRequest.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.order_publisher.SubmitChangesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.order_publisher.SubmitChangesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.order_publisher.SubmitChangesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.SubmitChangesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
changeRequestId: jspb.Message.getFieldWithDefault(msg, 1, 0),
workspaceId: jspb.Message.getFieldWithDefault(msg, 2, 0),
body: jspb.Message.getFieldWithDefault(msg, 3, ""),
attachedFilesList: jspb.Message.toObjectList(msg.getAttachedFilesList(),
    proto.order_publisher.ChangeRequestAttachedFile.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.order_publisher.SubmitChangesRequest}
 */
proto.order_publisher.SubmitChangesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.order_publisher.SubmitChangesRequest;
  return proto.order_publisher.SubmitChangesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.order_publisher.SubmitChangesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.order_publisher.SubmitChangesRequest}
 */
proto.order_publisher.SubmitChangesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setChangeRequestId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBody(value);
      break;
    case 4:
      var value = new proto.order_publisher.ChangeRequestAttachedFile;
      reader.readMessage(value,proto.order_publisher.ChangeRequestAttachedFile.deserializeBinaryFromReader);
      msg.addAttachedFiles(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.order_publisher.SubmitChangesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.order_publisher.SubmitChangesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.order_publisher.SubmitChangesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.SubmitChangesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChangeRequestId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getBody();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAttachedFilesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.order_publisher.ChangeRequestAttachedFile.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 change_request_id = 1;
 * @return {number}
 */
proto.order_publisher.SubmitChangesRequest.prototype.getChangeRequestId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.SubmitChangesRequest} returns this
 */
proto.order_publisher.SubmitChangesRequest.prototype.setChangeRequestId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 workspace_id = 2;
 * @return {number}
 */
proto.order_publisher.SubmitChangesRequest.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.SubmitChangesRequest} returns this
 */
proto.order_publisher.SubmitChangesRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string body = 3;
 * @return {string}
 */
proto.order_publisher.SubmitChangesRequest.prototype.getBody = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_publisher.SubmitChangesRequest} returns this
 */
proto.order_publisher.SubmitChangesRequest.prototype.setBody = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated ChangeRequestAttachedFile attached_files = 4;
 * @return {!Array<!proto.order_publisher.ChangeRequestAttachedFile>}
 */
proto.order_publisher.SubmitChangesRequest.prototype.getAttachedFilesList = function() {
  return /** @type{!Array<!proto.order_publisher.ChangeRequestAttachedFile>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.order_publisher.ChangeRequestAttachedFile, 4));
};


/**
 * @param {!Array<!proto.order_publisher.ChangeRequestAttachedFile>} value
 * @return {!proto.order_publisher.SubmitChangesRequest} returns this
*/
proto.order_publisher.SubmitChangesRequest.prototype.setAttachedFilesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.order_publisher.ChangeRequestAttachedFile=} opt_value
 * @param {number=} opt_index
 * @return {!proto.order_publisher.ChangeRequestAttachedFile}
 */
proto.order_publisher.SubmitChangesRequest.prototype.addAttachedFiles = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.order_publisher.ChangeRequestAttachedFile, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.order_publisher.SubmitChangesRequest} returns this
 */
proto.order_publisher.SubmitChangesRequest.prototype.clearAttachedFilesList = function() {
  return this.setAttachedFilesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.order_publisher.SubmitNewLiveLinkRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.order_publisher.SubmitNewLiveLinkRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.order_publisher.SubmitNewLiveLinkRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.SubmitNewLiveLinkRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
changeRequestId: jspb.Message.getFieldWithDefault(msg, 1, 0),
workspaceId: jspb.Message.getFieldWithDefault(msg, 2, 0),
newLiveUrl: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.order_publisher.SubmitNewLiveLinkRequest}
 */
proto.order_publisher.SubmitNewLiveLinkRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.order_publisher.SubmitNewLiveLinkRequest;
  return proto.order_publisher.SubmitNewLiveLinkRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.order_publisher.SubmitNewLiveLinkRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.order_publisher.SubmitNewLiveLinkRequest}
 */
proto.order_publisher.SubmitNewLiveLinkRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setChangeRequestId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setNewLiveUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.order_publisher.SubmitNewLiveLinkRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.order_publisher.SubmitNewLiveLinkRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.order_publisher.SubmitNewLiveLinkRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.SubmitNewLiveLinkRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChangeRequestId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getNewLiveUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional int64 change_request_id = 1;
 * @return {number}
 */
proto.order_publisher.SubmitNewLiveLinkRequest.prototype.getChangeRequestId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.SubmitNewLiveLinkRequest} returns this
 */
proto.order_publisher.SubmitNewLiveLinkRequest.prototype.setChangeRequestId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 workspace_id = 2;
 * @return {number}
 */
proto.order_publisher.SubmitNewLiveLinkRequest.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.SubmitNewLiveLinkRequest} returns this
 */
proto.order_publisher.SubmitNewLiveLinkRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string new_live_url = 3;
 * @return {string}
 */
proto.order_publisher.SubmitNewLiveLinkRequest.prototype.getNewLiveUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_publisher.SubmitNewLiveLinkRequest} returns this
 */
proto.order_publisher.SubmitNewLiveLinkRequest.prototype.setNewLiveUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.order_publisher.AddChangeRequestMessageRequest.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.order_publisher.AddChangeRequestMessageRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.order_publisher.AddChangeRequestMessageRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.order_publisher.AddChangeRequestMessageRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.AddChangeRequestMessageRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
changeRequestId: jspb.Message.getFieldWithDefault(msg, 1, 0),
workspaceId: jspb.Message.getFieldWithDefault(msg, 2, 0),
body: jspb.Message.getFieldWithDefault(msg, 3, ""),
attachedFilesList: jspb.Message.toObjectList(msg.getAttachedFilesList(),
    proto.order_publisher.ChangeRequestAttachedFile.toObject, includeInstance),
optionalReplyToMessageId: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.order_publisher.AddChangeRequestMessageRequest}
 */
proto.order_publisher.AddChangeRequestMessageRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.order_publisher.AddChangeRequestMessageRequest;
  return proto.order_publisher.AddChangeRequestMessageRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.order_publisher.AddChangeRequestMessageRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.order_publisher.AddChangeRequestMessageRequest}
 */
proto.order_publisher.AddChangeRequestMessageRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setChangeRequestId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBody(value);
      break;
    case 4:
      var value = new proto.order_publisher.ChangeRequestAttachedFile;
      reader.readMessage(value,proto.order_publisher.ChangeRequestAttachedFile.deserializeBinaryFromReader);
      msg.addAttachedFiles(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOptionalReplyToMessageId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.order_publisher.AddChangeRequestMessageRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.order_publisher.AddChangeRequestMessageRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.order_publisher.AddChangeRequestMessageRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_publisher.AddChangeRequestMessageRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChangeRequestId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getBody();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAttachedFilesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.order_publisher.ChangeRequestAttachedFile.serializeBinaryToWriter
    );
  }
  f = message.getOptionalReplyToMessageId();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional int64 change_request_id = 1;
 * @return {number}
 */
proto.order_publisher.AddChangeRequestMessageRequest.prototype.getChangeRequestId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.AddChangeRequestMessageRequest} returns this
 */
proto.order_publisher.AddChangeRequestMessageRequest.prototype.setChangeRequestId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 workspace_id = 2;
 * @return {number}
 */
proto.order_publisher.AddChangeRequestMessageRequest.prototype.getWorkspaceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.AddChangeRequestMessageRequest} returns this
 */
proto.order_publisher.AddChangeRequestMessageRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string body = 3;
 * @return {string}
 */
proto.order_publisher.AddChangeRequestMessageRequest.prototype.getBody = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_publisher.AddChangeRequestMessageRequest} returns this
 */
proto.order_publisher.AddChangeRequestMessageRequest.prototype.setBody = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated ChangeRequestAttachedFile attached_files = 4;
 * @return {!Array<!proto.order_publisher.ChangeRequestAttachedFile>}
 */
proto.order_publisher.AddChangeRequestMessageRequest.prototype.getAttachedFilesList = function() {
  return /** @type{!Array<!proto.order_publisher.ChangeRequestAttachedFile>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.order_publisher.ChangeRequestAttachedFile, 4));
};


/**
 * @param {!Array<!proto.order_publisher.ChangeRequestAttachedFile>} value
 * @return {!proto.order_publisher.AddChangeRequestMessageRequest} returns this
*/
proto.order_publisher.AddChangeRequestMessageRequest.prototype.setAttachedFilesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.order_publisher.ChangeRequestAttachedFile=} opt_value
 * @param {number=} opt_index
 * @return {!proto.order_publisher.ChangeRequestAttachedFile}
 */
proto.order_publisher.AddChangeRequestMessageRequest.prototype.addAttachedFiles = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.order_publisher.ChangeRequestAttachedFile, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.order_publisher.AddChangeRequestMessageRequest} returns this
 */
proto.order_publisher.AddChangeRequestMessageRequest.prototype.clearAttachedFilesList = function() {
  return this.setAttachedFilesList([]);
};


/**
 * optional int64 optional_reply_to_message_id = 5;
 * @return {number}
 */
proto.order_publisher.AddChangeRequestMessageRequest.prototype.getOptionalReplyToMessageId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_publisher.AddChangeRequestMessageRequest} returns this
 */
proto.order_publisher.AddChangeRequestMessageRequest.prototype.setOptionalReplyToMessageId = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * @enum {number}
 */
proto.order_publisher.PublisherWebsiteFilterField = {
  STRING_WEBSITE_DOMAIN: 0,
  STRING_WEBSITE_NAME: 1,
  NUMBER_WEBSITE_LINK_LIMIT: 2,
  NUMBER_WEBSITE_AHREF_DR: 3,
  NUMBER_WEBSITE_AHREF_TRAFFIC: 4,
  NUMBER_WEBSITE_MOZ_DA: 5,
  NUMBER_WEBSITE_SEMRUSH_AS: 6
};

/**
 * @enum {number}
 */
proto.order_publisher.PublisherWebsiteImportStatus = {
  PUBLISHER_WEBSITE_IMPORT_IN_PROGRESS: 0,
  PUBLISHER_WEBSITE_IMPORT_COMPLETED: 1,
  PUBLISHER_WEBSITE_IMPORT_CANCELED: 2
};

/**
 * @enum {number}
 */
proto.order_publisher.PublisherOrderFilterField = {
  STRING_ORDER_DOMAIN: 0,
  STRING_ORDER_TITLE: 1,
  NUMBER_ORDER_PRICE: 2,
  DROPDOWN_ORDER_STATUS: 3,
  DATE_ORDER_REQUESTED_AT: 4,
  DATE_ORDER_DEADLINE_AT: 5,
  DROPDOWN_ORDER_CHANGE_REQUEST_STATUS: 6,
  STRING_ORDER_NUMBER: 7
};

/**
 * @enum {number}
 */
proto.order_publisher.ChangeRequestStatus = {
  CHANGE_REQUEST_STATUS_UNSPECIFIED: 0,
  CHANGES_REQUESTED: 1,
  CHANGE_REQUEST_IN_REVIEW: 2,
  REVISING_DRAFT: 3,
  CHANGE_REQUEST_RESOLVED: 4
};

/**
 * @enum {number}
 */
proto.order_publisher.ChangeRequestArea = {
  CHANGE_REQUEST_AREA_UNSPECIFIED: 0,
  CHANGE_REQUEST_AREA_ANCHOR: 1,
  CHANGE_REQUEST_AREA_TARGET_URL: 2,
  CHANGE_REQUEST_AREA_CONTENT: 3,
  CHANGE_REQUEST_AREA_PLACEMENT: 4,
  CHANGE_REQUEST_AREA_OTHER: 5
};

/**
 * @enum {number}
 */
proto.order_publisher.ChangeRequestAuthorType = {
  CHANGE_REQUEST_AUTHOR_TYPE_UNSPECIFIED: 0,
  CHANGE_REQUEST_AUTHOR_TYPE_PUBLISHER: 1,
  CHANGE_REQUEST_AUTHOR_TYPE_RESPONA_TEAM: 2
};

/**
 * @enum {number}
 */
proto.order_publisher.SubmittedLiveUrlStatus = {
  SUBMITTED_LIVE_URL_STATUS_UNSPECIFIED: 0,
  SUBMITTED_LIVE_URL_PENDING: 1,
  SUBMITTED_LIVE_URL_APPROVED: 2,
  SUBMITTED_LIVE_URL_REJECTED: 3
};

goog.object.extend(exports, proto.order_publisher);
